// contributors-a1
//
// Purpose: Community contributor preset categories (A1)
//
// This module:
// - Exports preset categories: DX7FM, ThatBeepboxGuy, HoneykitKD, Calamity, truemori, The TuneCrusher, Bagel, DamageLol

import { toNameMap } from "../../../synth/synth-config";
import type { InputPresetCategory } from "./types";

export const contributorCategoriesA1: InputPresetCategory[] = [
	{
		name: "DX7FM's Presets",
		presets: toNameMap([
			{
				name: "Simple Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[6], [6, 3], [6], [6, 5], [6], []], carrierCount: 2 },
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 8, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Jungle Party Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 6,
					customAlgorithm: { mods: [[6, 3, 4, 2], [], [5], [], [], []], carrierCount: 2 },
					customFeedback: { mods: [[], [], [], [3], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "punch",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Devious Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus", "echo"],
					panDelay: 0,
					chorus: 14,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 1,
					customAlgorithm: {
						mods: [[2, 3, 4, 5, 6], [], [4], [], [6], []],
						carrierCount: 1,
					},
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "Gore Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["distortion"],
					distortion: 86,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[3, 4], [3], [5], [], [6], []], carrierCount: 2 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "Silly Brass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 0,
					chorus: 43,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 5,
					customAlgorithm: { mods: [[6, 4, 2], [4], [5], [6], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Lasergore",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["vibrato", "distortion"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 29,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1→2→3→4→5→6",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Devilsaw",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 500, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 16000,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 500, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 16000,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 1 },
					],
					eqSubFilters1: [],
					effects: ["distortion", "chorus", "echo"],
					distortion: 29,
					aliases: false,
					panDelay: 0,
					chorus: 57,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2, 5], [], [4], [5], [6], []], carrierCount: 1 },
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 7, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 10, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Bellbass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[6], [6], [], [], [6], []], carrierCount: 5 },
					operators: [
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
					],
				},
			},
			{
				name: "Funky Trumpet",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[6], [6], [], [], [6], []], carrierCount: 5 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "Harsh Dream EP",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chord type", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 0,
					chorus: 29,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[6, 5], [6], [6], [6], [], []], carrierCount: 4 },
					customFeedback: { mods: [[], [], [], [1], [5], [5]] },
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: true,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: true,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "Low Dirty Trumpet",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[6], [6, 3], [], [], [], []], carrierCount: 2 },
					customFeedback: { mods: [[], [], [3], [], [], [5]] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "feedbackAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Pennyghost",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chord type", "chorus"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "6⟲",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[6], [6], [6], [], [], []], carrierCount: 4 },
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "City Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 0,
					chorus: 57,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -3,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Lorgue 1",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 3,
					customAlgorithm: {
						mods: [[3, 2], [4, 3], [5, 4], [6, 5], [6], []],
						carrierCount: 6,
					},
					customFeedback: { mods: [[1], [2], [3], [4], [5], [5]] },
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Lorgue 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 3,
					customAlgorithm: {
						mods: [[3, 2], [4, 3], [5, 4], [6, 5], [6], []],
						carrierCount: 6,
					},
					customFeedback: { mods: [[1], [2], [3], [4], [5], [5]] },
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Lorgue 3",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 2,
					customAlgorithm: { mods: [[2], [3], [4], [5], [6], []], carrierCount: 6 },
					customFeedback: { mods: [[2], [3], [4], [5], [5], []] },
					operators: [
						{ frequency: "~4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Kaepbass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 7,
					customAlgorithm: { mods: [[2, 3], [], [], [], [], []], carrierCount: 1 },
					customFeedback: { mods: [[], [], [2], [], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Fartbass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus", "echo"],
					panDelay: 0,
					chorus: 29,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[2, 4], [3], [5], [5], [6], []], carrierCount: 1 },
					customFeedback: { mods: [[1], [], [3], [4], [5], [5]] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "feedbackAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: true,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorFrequency",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorFrequency",
							envelope: "flare",
							inverse: true,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Matrix EP",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chord type"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2], [3], [4, 5], [5], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "17×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "Nickelghost",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chord type", "granular", "chorus", "echo"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					granular: 4,
					grainSize: 22,
					grainAmounts: 4,
					grainRange: 17,
					panDelay: 0,
					chorus: 29,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 8,
					customAlgorithm: {
						mods: [[6, 4], [6, 4], [6, 4], [5], [6], []],
						carrierCount: 4,
					},
					customFeedback: { mods: [[4], [5], [5], [], [], []] },
					operators: [
						{ frequency: "0.75×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "Cyberdoom",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 707.11, linearGain: 2 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 707.11, linearGain: 2 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1.4142 },
					],
					eqSubFilters1: [],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 0,
					chorus: 43,
					echoSustain: 43,
					echoDelayBeats: 0.083,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Lorgue 4",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 2,
						},
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 2,
						},
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2 },
					],
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[2], [3], [4], [5], [6], []], carrierCount: 6 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Ouda Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "featured"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "2⟲",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[2], [3, 4], [6], [5], [6], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Qipao Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2, 3, 4], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Jianying Power",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "vibrato", "chorus", "echo"],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					chorus: 71,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2, 4], [3], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 10, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 8, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Dian EP",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 0,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "6⟲",
					feedbackAmplitude: 5,
					customAlgorithm: {
						mods: [[2], [3, 6], [4, 6], [5, 6], [6], []],
						carrierCount: 5,
					},
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Dian Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["echo"],
					panDelay: 0,
					echoSustain: 14,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: {
						mods: [[2, 3, 4, 5, 6], [], [], [], [], []],
						carrierCount: 1,
					},
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Pengke Pulse",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "2⟲",
					feedbackAmplitude: 5,
					customAlgorithm: { mods: [[2, 3], [3, 4], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 12, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			// JukeBox 0.1.6
			{
				name: "Cheer Alarm",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Clicksaw",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Feedback Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲",
					feedbackAmplitude: 13,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Aquakill",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "4⟲",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[2], [3], [4], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Devilsaw 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus", "echo"],
					panDelay: 0,
					chorus: 43,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "3⟲",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[2, 3, 4], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 8, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 8, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Normal Brass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 13,
					customAlgorithm: { mods: [[], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Helium",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 13,
					customAlgorithm: { mods: [[2], [3], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Dirt Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[2, 3, 6], [5], [4], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: true,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Flare Square",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "2⟲",
					feedbackAmplitude: 13,
					customAlgorithm: { mods: [[2, 3], [], [4], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Multiwave",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Rubberwave",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[4], [5], [6], [5], [], []], carrierCount: 3 },
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "Rubbergrave",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[4], [5], [6], [5], [], []], carrierCount: 3 },
					customFeedback: { mods: [[2], [1, 3], [2], [4], [5], [5]] },
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Aggro Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[2], [3], [], [], [], []], carrierCount: 1 },
					customFeedback: { mods: [[], [], [3], [], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 12, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "FM Pad String",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "featured", "string", "pad"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.3536 }],
					eqSubFilters1: [],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 10,
					chorus: 14,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 52,
					fadeInSeconds: 0.075,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Silli Lead",
				generalMidi: false,
				tags: ["chip", "customchip", "dx7fm", "featured", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "pitch shift", "vibrato", "chorus", "echo"],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 14,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					chorus: 71,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 23,
						"2": 22,
						"3": 21,
						"4": 20,
						"5": 19,
						"6": 18,
						"7": 17,
						"8": -18,
						"9": -18,
						"10": -18,
						"11": -18,
						"12": -18,
						"13": -18,
						"14": -18,
						"15": -18,
						"16": -18,
						"17": -18,
						"18": -18,
						"19": -18,
						"20": -1,
						"21": -2,
						"22": -3,
						"23": -4,
						"24": 1,
						"25": 4,
						"26": 6,
						"27": 6,
						"28": 6,
						"29": 4,
						"30": 1,
						"31": 1,
						"32": 1,
						"33": 1,
						"34": 4,
						"35": 6,
						"36": 6,
						"37": 6,
						"38": 4,
						"39": 1,
						"40": -4,
						"41": -3,
						"42": -2,
						"43": -1,
						"44": -18,
						"45": -18,
						"46": -18,
						"47": -18,
						"48": -18,
						"49": -18,
						"50": -18,
						"51": -18,
						"52": -18,
						"53": -18,
						"54": -18,
						"55": -18,
						"56": 17,
						"57": 18,
						"58": 19,
						"59": 20,
						"60": 21,
						"61": 22,
						"62": 23,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Piano Crush",
				generalMidi: false,
				tags: ["pickedstring", "dx7fm"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["pitch shift", "chorus", "echo", "reverb"],
					pitchShiftSemitones: 0,
					panDelay: 0,
					chorus: 100,
					echoSustain: 100,
					echoDelayBeats: 0.083,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
					],
					unison: "thin",
					stringSustain: 93,
					envelopes: [],
				},
			},
			// shifted over from community presets
			{
				name: "coolsaw",
				generalMidi: false,
				tags: ["chip", "chipwave", "dx7fm", "featured"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "vibrato", "chorus", "echo"],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					chorus: 71,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sawtooth",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Gadget Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "dx7fm"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
					],
					effects: [
						"panning",
						"pitch shift",
						"note filter",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					pitchShiftSemitones: 24,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 6,
					noteFilter: [{ type: "low-pass", cutoffHz: 7716.72, linearGain: 8 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 7716.72, linearGain: 8 }],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 57,
					pan: 0,
					panDelay: 0,
					chorus: 29,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3←4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							index: 0,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.6,
							discrete: true,
						},
					],
					isDrum: false,
				},
			},
			// JukeBox 0.2.0
			{
				name: "Funky Twang",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "Custom",
					feedbackAmplitude: 6,
					customFeedback: { mods: [[1], [], [3], [], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Spook EP",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[3, 2], [5], [4], [], [6], []], carrierCount: 2 },
					customFeedback: { mods: [[2], [], [], [], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Lorgue 5",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.0884 }],
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2], [3], [4], [5], [6], []], carrierCount: 6 },
					customFeedback: { mods: [[], [], [], [], [], []] },
					operators: [
						{ frequency: "16×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Funky Trumpet 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[6], [6], [], [], [6], []], carrierCount: 5 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
					],
				},
			},
			{
				name: "Twangus 1",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type"],
					transition: "normal",
					clicklessTransition: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Flare Square 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "2⟲",
					feedbackAmplitude: 7,
					customAlgorithm: { mods: [[2], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "pulse width", pulseWidth: 0 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Distant Dirt",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "Custom",
					feedbackAmplitude: 8,
					customFeedback: { mods: [[], [2], [3], [], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "ByteBass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 2378.41, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.1768 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 2378.41, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.1768 },
					],
					panDelay: 0,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[2], [4], [4], [5], [6], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Twangus 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chorus"],
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[3, 5], [4, 6], [], [], [], []], carrierCount: 2 },
					customFeedback: { mods: [[], [], [], [], [5], [5]] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Dexacord",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: {
						mods: [[2, 3, 4, 5, 6], [3], [], [], [], []],
						carrierCount: 1,
					},
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "Distant Morse",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chorus", "echo"],
					panDelay: 0,
					chorus: 29,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[4], [5], [6], [], [], []], carrierCount: 3 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Chiconde 1",
				generalMidi: false,
				tags: ["chip", "customchip", "dx7fm", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": -24,
						"2": 24,
						"3": -22,
						"4": 24,
						"5": -20,
						"6": 24,
						"7": -18,
						"8": 24,
						"9": -16,
						"10": 24,
						"11": -14,
						"12": 24,
						"13": -12,
						"14": 24,
						"15": -10,
						"16": 24,
						"17": -8,
						"18": 24,
						"19": -6,
						"20": 24,
						"21": -4,
						"22": 24,
						"23": -2,
						"24": 24,
						"25": 0,
						"26": 24,
						"27": 2,
						"28": 24,
						"29": 4,
						"30": 24,
						"31": 6,
						"32": 24,
						"33": 8,
						"34": 24,
						"35": 10,
						"36": 24,
						"37": 12,
						"38": 24,
						"39": 14,
						"40": 24,
						"41": 16,
						"42": 24,
						"43": 18,
						"44": 24,
						"45": 20,
						"46": 24,
						"47": 22,
						"48": 24,
						"49": 21,
						"50": 18,
						"51": 15,
						"52": 12,
						"53": 9,
						"54": 6,
						"55": 3,
						"56": 0,
						"57": -3,
						"58": -6,
						"59": -9,
						"60": -12,
						"61": -15,
						"62": -18,
						"63": -21,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Chiconde 2",
				generalMidi: false,
				tags: ["chip", "customchip", "dx7fm", "featured", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "pitch shift", "vibrato", "chorus", "echo"],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 14,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					chorus: 71,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 0,
						"1": -24,
						"2": 0,
						"3": 24,
						"4": 0,
						"5": -24,
						"6": 0,
						"7": 24,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": -24,
						"34": 0,
						"35": 24,
						"36": 0,
						"37": -24,
						"38": 0,
						"39": 24,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Coolpulse",
				generalMidi: false,
				tags: ["pwm", "dx7fm"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "chorus", "echo"],
					transition: "slide",
					clicklessTransition: false,
					panDelay: 0,
					chorus: 29,
					echoSustain: 29,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Dian Harmonics",
				generalMidi: false,
				tags: ["harmonics", "dx7fm"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 86, 71, 57, 43, 29, 14, 100, 86, 71, 57, 43, 29, 14, 100, 86, 71, 57,
						43, 29, 14, 100, 86, 71, 57, 43, 29, 14,
					],
					unison: "honky tonk",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Coolsupe",
				generalMidi: false,
				tags: ["supersaw", "dx7fm"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 0,
					chorus: 29,
					echoSustain: 29,
					echoDelayBeats: 0.75,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 50,
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Clangbang",
				generalMidi: false,
				tags: ["noise", "dx7fm"],
				settings: {
					type: "noise",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["pitch shift", "note filter", "chorus", "echo"],
					pitchShiftSemitones: 24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 0.3536,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 0.3536,
						},
					],
					panDelay: 10,
					chorus: 14,
					echoSustain: 43,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "clang",
					unison: "honky tonk",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Normal Brass 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[2, 3, 4], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Normal Brass 4",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 8,
					customAlgorithm: {
						mods: [[2, 3, 4, 5, 6], [], [], [], [], []],
						carrierCount: 1,
					},
					customFeedback: { mods: [[], [2], [3], [4], [5], [5]] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Bone EP",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["vibrato"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[3, 5], [4, 6], [], [], [], []], carrierCount: 2 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
					],
				},
			},
			{
				name: "Bone EP 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[4], [5], [6], [], [], []], carrierCount: 3 },
					customFeedback: { mods: [[], [], [], [4], [5], [5]] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "9×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
					],
				},
			},
			{
				name: "Bell Keys",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[4], [5], [6], [], [], []], carrierCount: 3 },
					customFeedback: { mods: [[], [], [], [], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Major Pad",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "pad"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[], [], [], [], [], []], carrierCount: 6 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Rain Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -3,
					algorithm: "Custom",
					feedbackType: "2⟲",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[2], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Simple Bell",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["reverb"],
					panDelay: 0,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "29EP",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.1768 }],
					eqSubFilters1: [],
					effects: ["chord type"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "2⟲",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[2], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "9×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "XYZ Growl",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["note filter", "distortion", "chorus", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.3536,
						},
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.3536,
						},
					],
					distortion: 14,
					aliases: false,
					panDelay: 0,
					chorus: 14,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "distortion",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "XYZ Rave",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["note filter", "chorus", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "peak", cutoffHz: 2378.41, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "peak", cutoffHz: 2378.41, linearGain: 11.3137 }],
					panDelay: 0,
					chorus: 14,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 5,
					customAlgorithm: { mods: [[2], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Twangus 3",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "2⟲",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[], [], [], [], [], []], carrierCount: 2 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Dididi",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Dexet",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chorus", "echo"],
					panDelay: 0,
					chorus: 14,
					echoSustain: 14,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 9,
					customAlgorithm: { mods: [[2], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.2.1--------------
			{
				name: "Kickle",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "kick"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["pitch shift", "note filter"],
					pitchShiftSemitones: 24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1000, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1000, linearGain: 0.1768 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "2⟲",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[2], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Hat Hat",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 500, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 500, linearGain: 0.1768 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2(3(4(5(6",
					feedbackType: "ALL",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: true,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Snaren",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "snare"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[4], [], [], [], [], []], carrierCount: 3 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "Tomple",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["pitch shift", "note filter", "distortion"],
					pitchShiftSemitones: 15,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 8,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 8,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					distortion: 14,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "distortion",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "North Pole",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["echo", "reverb"],
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 0.5,
					reverb: 68,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 96,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[6], [6], [6], [], [], []], carrierCount: 3 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Dusty EP",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "featured"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "vibrato", "chorus"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←4 2←5 3←6",
					feedbackType: "4→5",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "9×", amplitude: 3, waveform: "pulse width", pulseWidth: 4 },
						{
							frequency: "0.75×",
							amplitude: 2,
							waveform: "pulse width",
							pulseWidth: 3,
						},
						{ frequency: "3×", amplitude: 9, waveform: "pulse width", pulseWidth: 9 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Fight Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "Custom",
					feedbackAmplitude: 4,
					customFeedback: { mods: [[], [], [], [], [], [5]] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "18×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 1.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.9,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 11,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 18,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.9,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.3,
							discrete: false,
							index: 4,
							pitchEnvelopeStart: 41,
							pitchEnvelopeEnd: 46,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.9,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorAmplitude",
							envelope: "pitch",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							pitchEnvelopeStart: 24,
							pitchEnvelopeEnd: 72,
						},
						{
							target: "operatorAmplitude",
							envelope: "pitch",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
							pitchEnvelopeStart: 36,
							pitchEnvelopeEnd: 84,
						},
					],
				},
			},
			{
				name: "Toolbass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "(1 2 3 4 5)←6",
					feedbackType: "Custom",
					feedbackAmplitude: 3,
					customFeedback: { mods: [[1], [2], [3], [4], [5], [5]] },
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Deuxtrois EP",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chord type"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "4⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2, 3, 4], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "18×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Alpha Lead",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					effects: [
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 1.4142,
						},
					],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[], [], [], [], [], []], carrierCount: 6 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Netherlead",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 0.7071,
						},
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 0.7071,
						},
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.25 },
					],
					effects: ["chorus", "reverb"],
					panDelay: 0,
					chorus: 86,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[3], [], [4], [], [], []], carrierCount: 2 },
					operators: [
						{ frequency: "3×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "14×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Hundred Lead",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 7,
					eqSubFilters0: [],
					effects: ["note filter", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					panDelay: 0,
					echoSustain: 71,
					echoDelayBeats: 0.5,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			// -------------JukeBox 0.2.3--------------
			{
				name: "Unease Chip",
				generalMidi: false,
				tags: ["chip", "customchip", "dx7fm"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 1.4142,
						},
					],
					effects: ["chord type", "vibrato", "note filter"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "square",
					unison: "detune",
					customChipWave: {
						"0": -13,
						"1": -13,
						"2": -13,
						"3": 19,
						"4": 19,
						"5": 19,
						"6": 3,
						"7": 3,
						"8": 3,
						"9": -12,
						"10": -12,
						"11": -12,
						"12": 20,
						"13": 20,
						"14": 20,
						"15": -17,
						"16": -17,
						"17": -17,
						"18": 15,
						"19": 15,
						"20": 15,
						"21": -1,
						"22": -1,
						"23": -1,
						"24": -16,
						"25": -16,
						"26": -16,
						"27": 16,
						"28": 16,
						"29": 16,
						"30": -21,
						"31": -21,
						"32": 11,
						"33": 11,
						"34": 11,
						"35": -5,
						"36": -5,
						"37": -5,
						"38": -20,
						"39": -20,
						"40": -20,
						"41": 12,
						"42": 12,
						"43": 12,
						"44": -4,
						"45": -4,
						"46": -4,
						"47": 7,
						"48": 7,
						"49": 7,
						"50": -8,
						"51": -8,
						"52": -8,
						"53": -24,
						"54": -24,
						"55": -24,
						"56": 8,
						"57": 8,
						"58": 8,
						"59": -8,
						"60": -8,
						"61": 3,
						"62": 3,
						"63": 3,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Old Store Bell",
				generalMidi: false,
				tags: ["pickedstring", "dx7fm"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					effects: ["bitcrusher", "ring mod"],
					ringMod: 14,
					ringModHz: 100,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 14,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 0, 0, 100, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0,
					],
					unison: "honky tonk",
					stringSustain: 71,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Grain Choir",
				generalMidi: false,
				tags: ["harmonics", "dx7fm"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 },
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 8 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 },
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 8 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 2 },
					],
					effects: ["vibrato", "granular", "echo", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					granular: 3,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 0.833,
					reverb: 32,
					fadeInSeconds: 0.075,
					fadeOutTicks: 24,
					harmonics: [
						100, 57, 14, 14, 43, 29, 14, 0, 14, 14, 0, 14, 14, 0, 0, 14, 0, 14, 14, 14,
						0, 0, 14, 0, 0, 14, 14, 14,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Phonky Bass",
				generalMidi: false,
				tags: ["harmonics", "dx7fm", "featured"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					effects: ["chord type", "note filter", "distortion"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.0884 },
					],
					distortion: 71,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 86, 86, 86, 71, 14, 14, 100, 71, 57, 57, 43, 43, 29, 57, 57, 29,
						43, 57, 71, 71, 86, 86, 71, 57, 43, 14,
					],
					unison: "double octave",
					envelopes: [
						{
							target: "distortion",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Holy Grain",
				generalMidi: false,
				tags: ["pickedstring", "dx7fm"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "vibrato", "granular", "chorus", "reverb", "ring mod"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					ringMod: 14,
					ringModHz: 100,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					panDelay: 10,
					chorus: 29,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						100, 0, 0, 100, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0,
					],
					unison: "shimmer",
					stringSustain: 71,
					envelopes: [],
				},
			},
			{
				name: "Slepic",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chord type", "vibrato", "chorus", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					chorus: 14,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Notecube",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 5,
					customAlgorithm: { mods: [[3], [], [], [], [], []], carrierCount: 2 },
					operators: [
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 1, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "pulse width", pulseWidth: 3 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Bitpulse",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "Custom",
					feedbackType: "4⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[3, 4, 5], [3], [4], [], [], []], carrierCount: 2 },
					operators: [
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 2, waveform: "pulse width", pulseWidth: 3 },
						{ frequency: "0.5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "Bitpulse 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chord type"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 8,
					customAlgorithm: {
						mods: [[3, 5, 2], [4, 6], [5], [6], [], []],
						carrierCount: 2,
					},
					customFeedback: { mods: [[], [], [3], [4], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Bonkdonk",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["note filter", "distortion", "chorus", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.3536,
						},
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.3536,
						},
					],
					distortion: 14,
					aliases: false,
					panDelay: 0,
					chorus: 14,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2, 3], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "distortion",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Demon Lead",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 7,
					eqSubFilters0: [],
					effects: ["note filter", "distortion", "chorus", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 14,
					aliases: false,
					panDelay: 10,
					chorus: 14,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[2, 4], [3], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Window Twang",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 4,
					customAlgorithm: {
						mods: [[2, 3, 4, 5, 6], [3, 4, 5, 6], [], [], [], []],
						carrierCount: 1,
					},
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Dirty Bone Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1→2→3→4→5→6",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2, 3], [4, 6], [4], [5], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Hard Twang",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chord type", "note filter"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.1768 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 6,
					customAlgorithm: { mods: [[], [], [], [], [], []], carrierCount: 2 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "G2 Choir",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 11.3137 },
					],
					eqSubFilters1: [],
					effects: ["note filter", "distortion", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 11.3137 },
					],
					distortion: 0,
					aliases: false,
					panDelay: 0,
					chorus: 100,
					reverb: 100,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2, 3, 4, 5], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Deep Sea",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					effects: ["chorus", "echo", "reverb"],
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 52,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -3,
					algorithm: "Custom",
					feedbackType: "1→2→3→4→5→6",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[], [], [], [], [], []], carrierCount: 6 },
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Bojan",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					effects: ["echo", "reverb"],
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "Custom",
					feedbackType: "2⟲",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[2, 3], [3], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "False Square",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "featured"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chord type", "chorus", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 0,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "Custom",
					feedbackType: "3⟲",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[2, 3, 4], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Harsh Dream EP 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chord type", "chorus", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 0,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "Custom",
					feedbackType: "3⟲",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[2, 3, 4], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Kassi Aju",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.25,
						},
					],
					effects: ["vibrato", "note filter", "distortion", "echo"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 0.1768,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 0.1768,
						},
					],
					distortion: 29,
					aliases: false,
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 1.25,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -6,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 11,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "distortion",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Coolpulse 2",
				generalMidi: false,
				tags: ["pwm", "dx7fm", "featured"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.3536 }],
					effects: ["vibrato", "chorus", "echo", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					chorus: 71,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 25,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Waba",
				generalMidi: false,
				tags: ["pwm", "dx7fm"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 0.125,
						},
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 0.125,
						},
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.5 },
					],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 }],
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "triple octave",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Spouqui",
				generalMidi: false,
				tags: ["spectrum", "dx7fm"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 19027.31,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 19027.31,
							linearGain: 0.0884,
						},
					],
					effects: ["vibrato", "granular", "chorus", "reverb"],
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					granular: 1,
					grainSize: 50,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 0,
					chorus: 100,
					reverb: 42,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 96,
					spectrum: [
						86, 14, 0, 14, 0, 29, 0, 29, 14, 14, 14, 86, 43, 14, 71, 43, 86, 43, 100, 0,
						0, 71, 14, 0, 0, 0, 14, 43, 0, 14,
					],
					unison: "dissonant",
					envelopes: [],
				},
			},
			{
				name: "Hopesaw",
				generalMidi: false,
				tags: ["supersaw", "dx7fm"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [
						"vibrato",
						"note filter",
						"granular",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.1768 }],
					granular: 1,
					grainSize: 50,
					grainAmounts: 10,
					grainRange: 40,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 14,
					echoSustain: 57,
					echoDelayBeats: 1.25,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 100,
					spread: 0,
					shape: 33,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 0.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.8,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Cube Lead",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 11313.71,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 11313.71,
							linearGain: 2.8284,
						},
					],
					effects: ["transition type", "chorus", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					panDelay: 10,
					chorus: 29,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2, 3], [3], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Cheese",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.5 }],
					eqSubFilters1: [],
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2 }],
					panDelay: 10,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4←5←6)",
					feedbackType: "1→4",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 14, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 1, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 0, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 2, waveform: "pulse width", pulseWidth: 3 },
						{ frequency: "0.75×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 17,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Dexacord 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 8,
					customAlgorithm: {
						mods: [[2, 3, 4, 5, 6], [], [], [], [], []],
						carrierCount: 1,
					},
					customFeedback: { mods: [[], [2], [3], [4], [5], [5]] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "noteVolume",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Bit Saw",
				generalMidi: false,
				tags: ["supersaw", "dx7fm"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 8000,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 8000,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 },
					],
					effects: ["note filter", "distortion"],
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 27,
					decimalOffset: 0,
					dynamism: 100,
					spread: 17,
					shape: 50,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 0.3333,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "note size",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Tik Tik",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 1.4142,
						},
					],
					effects: ["chord type", "note filter"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.125 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←(2(3(4(5(6",
					feedbackType: "4→5",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.5×", amplitude: 14, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 1, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 0, waveform: "pulse width", pulseWidth: 4 },
						{ frequency: "4×", amplitude: 9, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 0.4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "OndesMartenot2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "featured"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 3,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"detune",
						"vibrato",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: 20,
					vibrato: "custom",
					vibratoDepth: 0.32,
					vibratoDelay: 27,
					vibratoSpeed: 12,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.0884 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					panDelay: 0,
					chorus: 14,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					reverb: 81,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -6,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Small Doom",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chord type"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[], [], [], [], [], []], carrierCount: 6 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.4--------------
			{
				name: "Holy Grain 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["granular", "chorus", "reverb"],
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 0,
					chorus: 29,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 15,
					customAlgorithm: { mods: [[], [], [], [], [], []], carrierCount: 6 },
					customFeedback: { mods: [[], [], [], [], [5], [5]] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Silli Pulse",
				generalMidi: false,
				tags: ["pwm", "dx7fm"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.25 }],
					effects: ["chord type", "vibrato", "echo", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					pulseWidth: 48,
					decimalOffset: 0,
					unison: "hum",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "FM Guitar",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 1.4142,
						},
					],
					effects: ["vibrato", "bitcrusher", "reverb"],
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 86,
					panDelay: 0,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 (3 (4 (5 (6",
					feedbackType: "1→6",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "0.5×",
							amplitude: 15,
							waveform: "pulse width",
							pulseWidth: 8,
						},
						{ frequency: "~1×", amplitude: 14, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "bitcrusherQuantization",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 0.01,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Afro Twang",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
					],
					eqSubFilters1: [
						{ type: "peak", cutoffHz: 105.11, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
					],
					eqSubFilters2: [
						{ type: "peak", cutoffHz: 105.11, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
					],
					effects: ["note filter", "bitcrusher", "chorus", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					chorus: 43,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←4(2←5 3←6",
					feedbackType: "3→4",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 11, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Plonk",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["bitcrusher"],
					bitcrusherOctave: 3,
					bitcrusherQuantization: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲",
					feedbackAmplitude: 11,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Squecho",
				generalMidi: false,
				tags: ["chip", "chipwave", "dx7fm"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.25 }],
					eqSubFilters1: [],
					effects: ["note filter", "chorus", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.25 }],
					panDelay: 10,
					chorus: 14,
					echoSustain: 71,
					echoDelayBeats: 1.333,
					fadeInSeconds: 0.075,
					fadeOutTicks: -6,
					wave: "lemmbox trapasquare",
					unison: "honky tonk",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 512,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Pulse Gibrass",
				generalMidi: false,
				tags: ["pwm", "dx7fm"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 500, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 500, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.5 },
					],
					effects: ["echo", "reverb"],
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "vibrate",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "flare",
							inverse: true,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Chiconde 3",
				generalMidi: false,
				tags: ["chip", "customchip", "dx7fm", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 19027.31,
							linearGain: 0.1768,
						},
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 19027.31,
							linearGain: 0.1768,
						},
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.7071 },
					],
					effects: ["vibrato", "chorus"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "trumpet",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 24,
						"2": -24,
						"3": 24,
						"4": 24,
						"5": -24,
						"6": 24,
						"7": 24,
						"8": -24,
						"9": 24,
						"10": 24,
						"11": -24,
						"12": -15,
						"13": -15,
						"14": -16,
						"15": -17,
						"16": -18,
						"17": -18,
						"18": -19,
						"19": -19,
						"20": -20,
						"21": -20,
						"22": -20,
						"23": -20,
						"24": -21,
						"25": -21,
						"26": -21,
						"27": -22,
						"28": -22,
						"29": -22,
						"30": -22,
						"31": -23,
						"32": -23,
						"33": -23,
						"34": -23,
						"35": -23,
						"36": -23,
						"37": -23,
						"38": -23,
						"39": -23,
						"40": -23,
						"41": -23,
						"42": -23,
						"43": -23,
						"44": -23,
						"45": -23,
						"46": -23,
						"47": -23,
						"48": -23,
						"49": -23,
						"50": -23,
						"51": -23,
						"52": -23,
						"53": -23,
						"54": -23,
						"55": -23,
						"56": -23,
						"57": -23,
						"58": -23,
						"59": -24,
						"60": -24,
						"61": -24,
						"62": -24,
						"63": -22,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 17,
							perEnvelopeLowerBound: 0.3,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Flower Saw",
				generalMidi: false,
				tags: ["supersaw", "dx7fm"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["distortion", "chorus", "echo", "reverb"],
					distortion: 14,
					aliases: false,
					panDelay: 0,
					chorus: 29,
					echoSustain: 57,
					echoDelayBeats: 1,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 67,
					spread: 83,
					shape: 50,
					envelopes: [],
				},
			},
			{
				name: "Flire Saw",
				generalMidi: false,
				tags: ["supersaw", "dx7fm"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "peak", cutoffHz: 500, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 176.78,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 500, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 176.78,
							linearGain: 2,
						},
					],
					effects: ["reverb"],
					panDelay: 0,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 48,
					decimalOffset: 0,
					dynamism: 83,
					spread: 8,
					shape: 17,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 0.8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Desert Moon",
				generalMidi: false,
				tags: ["pickedstring", "dx7fm"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 5.6569 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 5.6569 },
					],
					effects: ["vibrato", "note filter", "echo", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.125 }],
					panDelay: 0,
					echoSustain: 14,
					echoDelayBeats: 1,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 14, 43, 29, 43, 57, 29, 43, 43, 57, 57, 86, 100, 0, 29, 57, 29, 29, 14,
						57, 43, 57, 43, 14, 14, 0, 14, 14,
					],
					unison: "dissonant",
					stringSustain: 93,
					envelopes: [],
				},
			},
			{
				name: "Twangus 4",
				generalMidi: false,
				tags: ["pickedstring", "dx7fm"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.1768 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 86, 57, 57, 29, 29, 0, 86, 14, 57, 43, 86, 14, 14, 14, 43, 14, 14, 71,
						86, 43, 14, 14, 43, 14, 29, 14, 14,
					],
					unison: "octave",
					stringSustain: 36,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "High Star",
				generalMidi: false,
				tags: ["harmonics", "dx7fm"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.1768 }],
					effects: ["chord type", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 17,
					monoChordTone: 1,
					panDelay: 0,
					reverb: 23,
					fadeInSeconds: 0.0413,
					fadeOutTicks: -1,
					harmonics: [
						100, 71, 86, 71, 71, 71, 86, 71, 43, 43, 43, 29, 29, 29, 14, 14, 14, 14, 14,
						14, 14, 14, 14, 0, 0, 14, 14, 14,
					],
					unison: "hum",
					envelopes: [],
				},
			},
			{
				name: "Bit Saw 2",
				generalMidi: false,
				tags: ["supersaw", "dx7fm"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 8000,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 8000,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 },
					],
					effects: ["note filter", "distortion", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 2 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 2 },
					],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 47,
					decimalOffset: 0,
					dynamism: 100,
					spread: 8,
					shape: 33,
					envelopes: [],
				},
			},
			{
				name: "Guerilla Pad",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "pad"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.125 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.125,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.125 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.125,
						},
					],
					effects: ["chorus", "reverb"],
					panDelay: 10,
					chorus: 29,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←(2 3←5 4←6)",
					feedbackType: "ALL",
					feedbackAmplitude: 1,
					operators: [
						{ frequency: "~1×", amplitude: 14, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "13×", amplitude: 2, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 1, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 11, waveform: "ramp", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 14,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Strulse",
				generalMidi: false,
				tags: ["pwm", "dx7fm"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.25,
						},
					],
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 1.4142 }],
					panDelay: 0,
					reverb: 48,
					fadeInSeconds: 0.0575,
					fadeOutTicks: -6,
					pulseWidth: 35,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Strupersing",
				generalMidi: false,
				tags: ["supersaw", "dx7fm"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 5.6569,
						},
					],
					effects: ["pitch shift", "note filter", "bitcrusher", "reverb"],
					pitchShiftSemitones: 14,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 4 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 4 }],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					reverb: 19,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -6,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 100,
					spread: 83,
					shape: 17,
					envelopes: [
						{
							target: "pitchShift",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 6.5,
							perEnvelopeLowerBound: 1.2,
							perEnvelopeUpperBound: 1.7,
							discrete: false,
							waveform: 2,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 11,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 0.6,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Picked Bass 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "2→4",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Chemical Saw",
				generalMidi: false,
				tags: ["supersaw", "dx7fm"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 19027.31,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 19027.31,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 2 },
					],
					effects: ["vibrato", "note filter", "chorus", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.7071 }],
					panDelay: 0,
					chorus: 29,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 41,
					decimalOffset: 0,
					dynamism: 50,
					spread: 58,
					shape: 100,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 13,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Lorgue 6",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.3536 }],
					eqSubFilters1: [],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 10,
					chorus: 14,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 26,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Groovy Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.7071 },
					],
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 }],
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 1,
					customAlgorithm: { mods: [[3], [3], [], [], [], []], carrierCount: 2 },
					operators: [
						{ frequency: "0.12×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 9, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 1, waveform: "pulse width", pulseWidth: 1 },
						{ frequency: "1×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
							waveform: 0,
							steps: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Time Pulse",
				generalMidi: false,
				tags: ["pwm", "dx7fm"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 }],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Distant Saw",
				generalMidi: false,
				tags: ["supersaw", "dx7fm"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.1768,
						},
					],
					effects: ["chord type", "note filter", "distortion", "bitcrusher", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
					],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 29,
					panDelay: 0,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 47,
					decimalOffset: 0,
					dynamism: 67,
					spread: 0,
					shape: 50,
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Sega Type Pluck",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 1,
					customAlgorithm: { mods: [[3], [4], [], [], [], []], carrierCount: 2 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 1, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "12×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "1×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Playstation FM",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 4 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 4 }],
					panDelay: 0,
					chorus: 100,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "2→3",
					feedbackAmplitude: 10,
					customAlgorithm: { mods: [[3, 4], [3, 4], [4], [], [], []], carrierCount: 2 },
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Hyper Harmonics",
				generalMidi: false,
				tags: ["harmonics", "dx7fm"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["bitcrusher", "echo", "reverb"],
					bitcrusherOctave: 6,
					bitcrusherQuantization: 86,
					panDelay: 0,
					echoSustain: 14,
					echoDelayBeats: 1,
					reverb: 19,
					fadeInSeconds: 0.0413,
					fadeOutTicks: -1,
					harmonics: [
						100, 57, 43, 86, 43, 57, 57, 14, 29, 29, 29, 14, 14, 14, 14, 29, 29, 0, 0,
						0, 0, 14, 0, 14, 14, 14, 14, 0,
					],
					unison: "triple octave",
					envelopes: [
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Vulxel",
				generalMidi: false,
				tags: ["pwm", "dx7fm"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "peak", cutoffHz: 2378.41, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 2378.41, linearGain: 1.4142 }],
					effects: ["granular"],
					granular: 10,
					grainSize: 28,
					grainAmounts: 9,
					grainRange: 10,
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -3,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "granular",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "grainFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 1.1,
							perEnvelopeUpperBound: 1.5,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 0.7,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Minus Saw",
				generalMidi: false,
				tags: ["supersaw", "dx7fm"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 67,
					spread: 33,
					shape: 33,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Hard Flire Saw",
				generalMidi: false,
				tags: ["supersaw", "dx7fm"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.3536 }],
					effects: ["note filter", "distortion", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 }],
					distortion: 14,
					aliases: false,
					panDelay: 0,
					echoSustain: 0,
					echoDelayBeats: 1,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 47,
					decimalOffset: 0,
					dynamism: 100,
					spread: 42,
					shape: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "reverb",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 2,
							steps: 2,
						},
						{
							target: "pulseWidth",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 0.3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Haunted Glass",
				generalMidi: false,
				tags: ["pickedstring", "dx7fm"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 11.3137,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 11.3137,
						},
					],
					effects: ["chord type", "detune", "vibrato", "granular", "reverb", "ring mod"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					detuneCents: -30,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					granular: 5,
					grainSize: 44,
					grainAmounts: 8,
					grainRange: 3,
					ringMod: 29,
					ringModHz: 100,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					panDelay: 0,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 0, 14, 0, 43, 0, 0, 0, 0, 71, 43, 0, 29, 0, 0, 0, 0, 71, 100, 0, 0,
						100, 0, 71, 0, 0, 0, 0,
					],
					unison: "none",
					stringSustain: 57,
					envelopes: [
						{
							target: "granular",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "ringModulation",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "detune",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Glistening Keys",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.3536 }],
					effects: ["pitch shift", "echo"],
					pitchShiftSemitones: 11,
					panDelay: 0,
					echoSustain: 29,
					echoDelayBeats: 1.5,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 2, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "dx7fm"], settings: {} },
		]),
	},
	{
		name: "ThatBeepboxGuy's Presets",
		presets: toNameMap([
			{
				name: "Better Distortion Guitar",
				generalMidi: false,
				tags: ["pickedstring", "thatbeepboxguy", "featured"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 1 },
					],
					effects: [
						"panning",
						"transition type",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 0,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 500, linearGain: 2.8284 },
						{
							type: "low-pass",
							cutoffHz: 1189.21,
							linearGain: 2,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 500, linearGain: 2.8284 },
						{
							type: "low-pass",
							cutoffHz: 1189.21,
							linearGain: 2,
						},
					],
					distortion: 100,
					aliases: false,
					pan: 0,
					panDelay: 20,
					chorus: 71,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 100, 86, 86, 86, 86, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 57,
						57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
					],
					unison: "none",
					stringSustain: 64,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Rude Harmonic",
				generalMidi: false,
				tags: ["pickedstring", "thatbeepboxguy"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					eqSubFilters1: [],
					effects: [
						"panning",
						"detune",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					detuneCents: 0,
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 29,
					pan: 0,
					panDelay: 10,
					chorus: 43,
					echoSustain: 0,
					echoDelayBeats: 1,
					reverb: 55,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						100, 57, 0, 57, 0, 0, 0, 57, 0, 0, 0, 0, 71, 0, 100, 43, 0, 0, 14, 86, 0,
						14, 0, 0, 0, 0, 0, 29,
					],
					unison: "octave",
					stringSustain: 86,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Distortion Supersaw",
				generalMidi: false,
				tags: ["supersaw", "thatbeepboxguy"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 4 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.1768 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 4 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.1768 },
					],
					effects: ["panning", "note filter", "distortion", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 2,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 2,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 }],
					distortion: 100,
					aliases: false,
					pan: 0,
					panDelay: 0,
					chorus: 100,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 1,
					decimalOffset: 0,
					dynamism: 100,
					spread: 67,
					shape: 0,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Dubstep Scream",
				generalMidi: false,
				tags: ["fm", "fm6op", "thatbeepboxguy"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 1.4142,
						},
					],
					effects: ["panning", "detune", "note filter", "bitcrusher", "chorus"],
					detuneCents: 36,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.25 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					pan: 0,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2←5 (3 4)←6",
					feedbackType: "2⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "0.12×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 13, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{
							frequency: "0.75×",
							amplitude: 2,
							waveform: "pulse width",
							pulseWidth: 4,
						},
						{ frequency: "0.75×", amplitude: 6, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 0.2,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
							index: 5,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Ambient Pad",
				generalMidi: false,
				tags: ["fm", "fm6op", "thatbeepboxguy", "pad"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 4 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 4 }],
					eqSubFilters1: [],
					effects: ["panning", "detune", "vibrato", "note filter", "chorus", "reverb"],
					detuneCents: 0,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					pan: 0,
					panDelay: 0,
					chorus: 100,
					reverb: 48,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1←3 2←(4 5←6)",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "1×", amplitude: 3, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 2, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Circus Synth",
				generalMidi: false,
				tags: ["chip", "chipwave", "thatbeepboxguy"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["panning", "transition type", "chorus"],
					transition: "normal",
					clicklessTransition: false,
					pan: 0,
					panDelay: 0,
					chorus: 57,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sawtooth",
					unison: "hum",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Granular Synth",
				generalMidi: false,
				tags: ["chip", "chipwave", "thatbeepboxguy"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["panning", "transition type", "chord type", "granular", "chorus"],
					transition: "normal",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					granular: 2,
					grainSize: 49,
					grainAmounts: 4,
					grainRange: 40,
					pan: 0,
					panDelay: 0,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sharp clarinet",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Buzz Saw V2",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					effects: ["transition type", "distortion", "chorus", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					distortion: 71,
					aliases: false,
					chorus: 43,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1←2←3←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "11×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Distant Scream",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 2.8284,
						},
					],
					eqSubFilters1: [],
					effects: ["panning", "transition type", "distortion", "chorus", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					distortion: 29,
					aliases: false,
					pan: 0,
					panDelay: 10,
					chorus: 43,
					reverb: 48,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1→3 2→4",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "16×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Corrupted Synth",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.1768 }],
					effects: ["panning", "pitch shift", "chorus", "reverb"],
					pitchShiftSemitones: 12,
					pan: 0,
					panDelay: 0,
					chorus: 86,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "(12)←3←4",
					feedbackType: "1→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 14, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "1×", amplitude: 12, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "14×", amplitude: 1, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Chip Pad",
				generalMidi: false,
				tags: ["chip", "customchip", "thatbeepboxguy", "chiptune"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 }],
					eqSubFilters1: [],
					effects: ["panning", "note filter", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					pan: 0,
					panDelay: 0,
					chorus: 86,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "brucebox pokey 5step bass",
					unison: "octave",
					customChipWave: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 24,
						"14": 24,
						"15": 24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Dirty Guitar",
				generalMidi: false,
				tags: ["pickedstring", "thatbeepboxguy", "featured"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.125 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.125 },
					],
					effects: [
						"panning",
						"transition type",
						"chord type",
						"note filter",
						"distortion",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 4000,
							linearGain: 0.3536,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 4000,
							linearGain: 0.3536,
						},
					],
					distortion: 0,
					aliases: false,
					pan: 0,
					panDelay: 10,
					chorus: 57,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						86, 100, 100, 86, 86, 86, 86, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 57,
						57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
					],
					unison: "dirty",
					stringSustain: 86,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Sawcrush Pad",
				generalMidi: false,
				tags: ["supersaw", "thatbeepboxguy", "pad"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 57,
					panDelay: 10,
					chorus: 71,
					echoSustain: 0,
					echoDelayBeats: 0.083,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 40,
					decimalOffset: 0,
					dynamism: 100,
					spread: 8,
					shape: 67,
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 9,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
						{
							target: "reverb",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Ascent Synth",
				generalMidi: false,
				tags: ["chip", "customchip", "thatbeepboxguy", "chiptune"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.5 }],
					effects: [
						"panning",
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"distortion",
						"chorus",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 12,
					detuneCents: 0,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 0,
					aliases: false,
					pan: 0,
					panDelay: 0,
					chorus: 100,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -1,
						"1": -1,
						"2": -1,
						"3": -1,
						"4": -1,
						"5": -1,
						"6": -1,
						"7": -1,
						"8": -1,
						"9": -5,
						"10": -5,
						"11": -5,
						"12": -4,
						"13": -4,
						"14": -4,
						"15": -3,
						"16": -3,
						"17": -3,
						"18": -7,
						"19": -7,
						"20": -6,
						"21": -6,
						"22": -5,
						"23": -5,
						"24": -4,
						"25": -4,
						"26": -4,
						"27": -7,
						"28": -7,
						"29": -6,
						"30": -6,
						"31": -5,
						"32": -5,
						"33": -4,
						"34": -4,
						"35": -4,
						"36": -8,
						"37": -8,
						"38": -7,
						"39": -7,
						"40": -6,
						"41": -6,
						"42": -5,
						"43": -5,
						"44": -4,
						"45": -4,
						"46": 21,
						"47": 20,
						"48": 18,
						"49": 17,
						"50": 16,
						"51": 14,
						"52": 13,
						"53": 12,
						"54": 11,
						"55": 7,
						"56": 6,
						"57": 6,
						"58": 5,
						"59": 5,
						"60": 5,
						"61": 4,
						"62": 4,
						"63": 4,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Weird FM Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["panning", "bitcrusher", "chorus", "reverb"],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 86,
					pan: 0,
					panDelay: 10,
					chorus: 71,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 5, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Distant Choir",
				generalMidi: false,
				tags: ["spectrum", "thatbeepboxguy"],
				settings: {
					type: "spectrum",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 2828.43,
							linearGain: 1.4142,
						},
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 2828.43,
							linearGain: 1.4142,
						},
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 4 },
					],
					effects: ["panning", "detune", "note filter", "granular", "chorus", "reverb"],
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					pan: 0,
					panDelay: 0,
					chorus: 100,
					reverb: 52,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 12,
					spectrum: [
						43, 14, 14, 14, 14, 14, 14, 100, 14, 14, 14, 57, 14, 14, 100, 14, 43, 14,
						43, 14, 14, 43, 14, 29, 14, 29, 14, 14, 29, 0,
					],
					unison: "dirty",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Consistent Bass",
				generalMidi: false,
				tags: ["harmonics", "thatbeepboxguy"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.25 }],
					effects: ["panning", "chord type", "note filter", "distortion", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					distortion: 29,
					aliases: false,
					pan: 0,
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 86, 71, 57, 43, 43, 43, 29, 29, 29, 29, 29, 29, 29, 14, 14, 14, 14, 14,
						14, 14, 14, 14, 14, 14, 14, 14, 14,
					],
					unison: "bass",
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Ominous Ambience",
				generalMidi: false,
				tags: ["pickedstring", "thatbeepboxguy"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2.8284 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2.8284 }],
					effects: ["panning", "distortion", "bitcrusher", "chorus"],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					pan: 0,
					panDelay: 0,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						100, 86, 86, 86, 43, 57, 43, 71, 43, 43, 43, 57, 43, 43, 57, 71, 57, 43, 29,
						43, 57, 57, 43, 29, 29, 29, 29, 14,
					],
					unison: "octave",
					stringSustain: 93,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "FM Impact",
				generalMidi: false,
				tags: ["fm", "fm6op", "thatbeepboxguy"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 4 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 4 }],
					effects: [
						"panning",
						"transition type",
						"pitch shift",
						"note filter",
						"chorus",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					pitchShiftSemitones: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					pan: 0,
					panDelay: 10,
					chorus: 86,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 10, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 7, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 6, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Small Pluck",
				generalMidi: false,
				tags: ["pickedstring", "thatbeepboxguy"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					effects: ["panning", "transition type", "chorus", "echo", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					pan: 0,
					panDelay: 10,
					chorus: 29,
					echoSustain: 0,
					echoDelayBeats: 0.083,
					reverb: 55,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					harmonics: [
						100, 86, 57, 0, 0, 57, 57, 57, 86, 57, 57, 43, 43, 43, 29, 29, 14, 14, 29,
						14, 14, 14, 29, 100, 57, 43, 14, 14,
					],
					unison: "none",
					stringSustain: 14,
					envelopes: [],
					isDrum: false,
				},
			},
			// -------------JukeBox 0.2.0--------------
			{
				name: "Bass Pad",
				generalMidi: false,
				tags: ["chip", "chipwave", "thatbeepboxguy", "bass", "pad"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 11.3137 },
						{
							type: "low-pass",
							cutoffHz: 13454.34,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 11.3137 },
						{
							type: "low-pass",
							cutoffHz: 13454.34,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.0884 },
					],
					effects: ["chorus", "reverb"],
					panDelay: 0,
					chorus: 100,
					reverb: 48,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "modbox atari bass",
					unison: "dirty",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 15,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Distorted FM Vocal",
				generalMidi: false,
				tags: ["fm", "fm6op", "thatbeepboxguy"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 8000,
							linearGain: 4,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 8000,
							linearGain: 4,
						},
					],
					effects: ["panning", "note filter", "distortion", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 2.8284 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 2.8284 },
					],
					distortion: 86,
					aliases: false,
					pan: 0,
					panDelay: 0,
					chorus: 29,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 (3 4 5)←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "0.25×",
							amplitude: 7,
							waveform: "pulse width",
							pulseWidth: 3,
						},
						{ frequency: "0.5×", amplitude: 11, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 13, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Echo Pluck",
				generalMidi: false,
				tags: ["harmonics", "thatbeepboxguy"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					effects: ["panning", "vibrato", "note filter", "echo", "reverb"],
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					pan: 0,
					panDelay: 10,
					echoSustain: 14,
					echoDelayBeats: 2,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						100, 29, 43, 57, 57, 71, 86, 71, 71, 71, 86, 86, 71, 71, 86, 71, 71, 71, 86,
						71, 100, 86, 86, 57, 71, 86, 86, 71,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Raw Guitar Supersaw",
				generalMidi: false,
				tags: ["supersaw", "thatbeepboxguy"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 1.4142 },
					],
					effects: ["panning", "chord type", "bitcrusher", "chorus", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					pan: 0,
					panDelay: 10,
					chorus: 43,
					reverb: 45,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 47,
					decimalOffset: 0,
					dynamism: 100,
					spread: 33,
					shape: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "FM Banjo",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"panning",
						"chord type",
						"note filter",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 11313.71, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 0.25,
						},
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 11313.71, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 0.25,
						},
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.5 }],
					distortion: 14,
					aliases: false,
					pan: 0,
					panDelay: 0,
					chorus: 14,
					echoSustain: 0,
					echoDelayBeats: 0.083,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←(2 (3 (4",
					feedbackType: "1→3",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "pulse width", pulseWidth: 7 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
							index: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "reverb",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.3,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
							pitchEnvelopeStart: 19,
							pitchEnvelopeEnd: 55,
						},
					],
					isDrum: false,
				},
			},
			// -------------JukeBox 0.1.6--------------
			{
				name: "Hardcore Kick [C1]",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy", "kick"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "distortion"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 4 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 4 }],
					distortion: 86,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "10×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Freedom Bells",
				generalMidi: false,
				tags: ["pickedstring", "thatbeepboxguy", "featured"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 13454.34,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 13454.34,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2.8284 },
					],
					effects: ["chord type", "vibrato", "chorus", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 0.75,
					reverb: 65,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						0, 0, 71, 0, 0, 0, 0, 100, 0, 0, 86, 57, 71, 0, 14, 43, 29, 0, 86, 0, 0, 0,
						14, 0, 0, 0, 100, 0,
					],
					unison: "none",
					stringSustain: 64,
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.0--------------
			{
				name: "Dummy Clarinet (Undertale)",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.7071,
						},
					],
					effects: ["detune", "vibrato", "chorus", "reverb"],
					detuneCents: 0,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					chorus: 43,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2←3←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 2, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "chorus",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "King Pulse",
				generalMidi: false,
				tags: ["pwm", "thatbeepboxguy"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "chorus", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					panDelay: 0,
					chorus: 43,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 25,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 1.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Jackson Saw",
				generalMidi: false,
				tags: ["supersaw", "thatbeepboxguy"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "peak", cutoffHz: 2000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 2 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 2 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 2000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 2 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 2 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 1 },
					],
					effects: [
						"transition type",
						"detune",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					chorus: 71,
					echoSustain: 0,
					echoDelayBeats: 0.083,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 40,
					decimalOffset: 0,
					dynamism: 100,
					spread: 42,
					shape: 67,
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 9,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
						{
							target: "reverb",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Mysterious Steel Pan",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 4 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 4 }],
					effects: ["pitch shift", "vibrato", "note filter", "chorus", "reverb"],
					pitchShiftSemitones: 24,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 105.11, linearGain: 4 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 105.11, linearGain: 4 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					panDelay: 0,
					chorus: 100,
					reverb: 0,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 96,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Terror Lead",
				generalMidi: false,
				tags: ["pwm", "thatbeepboxguy"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.0884 },
					],
					effects: [
						"chord type",
						"vibrato",
						"note filter",
						"granular",
						"distortion",
						"chorus",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 4,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 4,
						},
					],
					granular: 3,
					grainSize: 40,
					grainAmounts: 5,
					grainRange: 19,
					distortion: 100,
					aliases: false,
					panDelay: 10,
					chorus: 86,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 45,
					decimalOffset: 0,
					unison: "octave",
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Ocean Bells",
				generalMidi: false,
				tags: ["pickedstring", "thatbeepboxguy"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 5.6569,
						},
					],
					effects: ["chord type", "note filter", "echo", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 4,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 4,
						},
					],
					panDelay: 0,
					echoSustain: 0,
					echoDelayBeats: 0.083,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 71, 86, 86, 29, 0, 57, 43, 14, 0, 14, 0, 29, 14, 14, 43, 29, 57, 0, 71,
						43, 43, 14, 0, 14, 29, 29, 29,
					],
					unison: "none",
					stringSustain: 21,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 20,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 0.7,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Spectral Grains",
				generalMidi: false,
				tags: ["pwm", "thatbeepboxguy"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.0884 },
					],
					effects: ["granular", "chorus"],
					granular: 5,
					grainSize: 43,
					grainAmounts: 7,
					grainRange: 31,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 47,
					decimalOffset: 0,
					unison: "octave",
					envelopes: [],
				},
			},
			{
				name: "Overcharged Pulse",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 2.8284 },
					],
					effects: ["vibrato", "note filter", "distortion", "chorus", "reverb"],
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 2,
						},
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.3536 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 2,
						},
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.3536 },
					],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					chorus: 43,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4",
					feedbackType: "3→4",
					feedbackAmplitude: 0,
					operators: [
						{
							frequency: "0.5×",
							amplitude: 13,
							waveform: "pulse width",
							pulseWidth: 7,
						},
						{ frequency: "2×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "War Pad",
				generalMidi: false,
				tags: ["fm", "fm6op", "thatbeepboxguy", "pad"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 707.11, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 11.3137,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 707.11, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 11.3137,
						},
					],
					eqSubFilters1: [],
					effects: ["chorus", "reverb"],
					panDelay: 0,
					chorus: 100,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←3 2←(4 5)←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 13,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{
							frequency: "0.12×",
							amplitude: 15,
							waveform: "pulse width",
							pulseWidth: 6,
						},
						{ frequency: "3.5×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 1, waveform: "pulse width", pulseWidth: 9 },
						{ frequency: "~2×", amplitude: 7, waveform: "trapezoid", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "CoruSynth",
				generalMidi: false,
				tags: ["chip", "chipwave", "thatbeepboxguy"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.125 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.125 },
					],
					effects: [
						"transition type",
						"pitch shift",
						"granular",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					granular: 3,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 0,
					echoSustain: 43,
					echoDelayBeats: 1.5,
					reverb: 58,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					wave: "sharp clarinet",
					unison: "corrupt",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "CoruPad",
				generalMidi: false,
				tags: ["chip", "chipwave", "thatbeepboxguy", "pad"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.3536 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.3536 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 1 },
					],
					effects: ["transition type", "pitch shift", "chorus", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					panDelay: 0,
					chorus: 100,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "double pulse",
					unison: "corrupt",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 16,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "CoruLead",
				generalMidi: false,
				tags: ["chip", "chipwave", "thatbeepboxguy", "lead"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 4 },
						{ type: "peak", cutoffHz: 500, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 4 },
						{ type: "peak", cutoffHz: 500, linearGain: 1 },
					],
					effects: [
						"transition type",
						"vibrato",
						"granular",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					granular: 2,
					grainSize: 49,
					grainAmounts: 5,
					grainRange: 40,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 71,
					panDelay: 0,
					chorus: 100,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sandbox saw bass",
					unison: "corrupt",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 35,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "NastyFM",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 5.6569 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 62.5, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2000, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 5.6569 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 62.5, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2000, linearGain: 4 },
					],
					effects: ["transition type", "vibrato", "bitcrusher", "chorus", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 86,
					panDelay: 10,
					chorus: 57,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1←(2 (3 (4",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorFrequency",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Chip Piano",
				generalMidi: false,
				tags: ["chip", "chipwave", "thatbeepboxguy", "keys"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "peak", cutoffHz: 1681.79, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 1681.79, linearGain: 0.1768 }],
					effects: ["note filter", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.25,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.25,
						},
					],
					panDelay: 0,
					chorus: 43,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "zefbox deep pulse",
					unison: "piano",
					isUsingAdvancedLoopControls: true,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 15,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 4,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Hardcore Kick 2",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy", "kick"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 19027.31, linearGain: 2 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 62.5, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 19027.31, linearGain: 2 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 62.5, linearGain: 0.3536 },
					],
					effects: ["note filter", "distortion", "bitcrusher"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 4 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 4 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 100,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "10×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "75×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "distortion",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 0.5,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Instant Pulse",
				generalMidi: false,
				tags: ["chip", "chipwave", "thatbeepboxguy"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 2 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 4 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 2 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 4 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 11.3137 },
					],
					eqSubFilters1: [],
					effects: ["transition type", "chord type", "granular", "distortion", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					granular: 3,
					grainSize: 49,
					grainAmounts: 1,
					grainRange: 40,
					distortion: 100,
					aliases: false,
					panDelay: 0,
					reverb: 48,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "double pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 16,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.3--------------
			{
				name: "Another Distortion Guitar",
				generalMidi: false,
				tags: ["pickedstring", "thatbeepboxguy"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.1768 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 4 },
						{ type: "peak", cutoffHz: 8000, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.1768 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 4 },
						{ type: "peak", cutoffHz: 8000, linearGain: 1.4142 },
					],
					eqSubFilters1: [],
					effects: ["note filter", "distortion", "bitcrusher", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 2.8284,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 2.8284,
						},
					],
					distortion: 57,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					panDelay: 10,
					chorus: 57,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 71, 57, 43, 43, 43, 29, 29, 29, 43, 43, 43, 57, 43, 43, 43, 43, 43, 43,
						29, 43, 29, 14, 29, 29, 29, 14, 29,
					],
					unison: "shimmer",
					stringSustain: 7,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Heavenly Music Box",
				generalMidi: false,
				tags: ["pickedstring", "thatbeepboxguy"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "peak", cutoffHz: 16000, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 16000, linearGain: 0.7071 }],
					effects: ["granular", "bitcrusher", "chorus", "echo", "reverb"],
					granular: 3,
					grainSize: 49,
					grainAmounts: 5,
					grainRange: 40,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 29,
					panDelay: 0,
					chorus: 71,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 61,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						100, 100, 0, 100, 0, 0, 0, 100, 0, 0, 100, 0, 0, 0, 0, 100, 0, 0, 0, 86, 0,
						0, 0, 0, 0, 0, 71, 0,
					],
					unison: "double octave",
					stringSustain: 79,
					envelopes: [],
				},
			},
			{
				name: "Highly Modified Square",
				generalMidi: false,
				tags: ["chip", "chipwave", "thatbeepboxguy"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.25 },
					],
					effects: [
						"transition type",
						"detune",
						"granular",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 0,
					granular: 1,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 29,
					panDelay: 0,
					chorus: 43,
					echoSustain: 57,
					echoDelayBeats: 1.25,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 6.1,
					unisonOffset: 6,
					unisonExpression: 0.8,
					unisonSign: 1,
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "unison",
							envelope: "blip",
							inverse: true,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Supersaw Slide Pulse",
				generalMidi: false,
				tags: ["supersaw", "thatbeepboxguy"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.125 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 2 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 8000, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 1 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.125 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 2 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 8000, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 1 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 2 },
					],
					eqSubFilters1: [],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"granular",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 0,
					detuneCents: 0,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.3536 }],
					granular: 1,
					grainSize: 49,
					grainAmounts: 5,
					grainRange: 40,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					chorus: 100,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					pulseWidth: 35,
					decimalOffset: 0,
					dynamism: 100,
					spread: 83,
					shape: 17,
					envelopes: [
						{
							target: "pitchShift",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "supersawDynamism",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Square Blip",
				generalMidi: false,
				tags: ["chip", "chipwave", "thatbeepboxguy"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 13454.34,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 13454.34,
							linearGain: 0.0884,
						},
					],
					effects: ["transition type", "chorus", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					panDelay: 10,
					chorus: 71,
					echoSustain: 43,
					echoDelayBeats: 0.25,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "unison",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Universe Triangle",
				generalMidi: false,
				tags: ["chip", "chipwave", "thatbeepboxguy"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 62.5, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 4 },
						{ type: "peak", cutoffHz: 4000, linearGain: 5.6569 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 62.5, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 4 },
						{ type: "peak", cutoffHz: 4000, linearGain: 5.6569 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 4 },
					],
					effects: ["vibrato", "granular", "chorus", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					granular: 1,
					grainSize: 44,
					grainAmounts: 5,
					grainRange: 22,
					panDelay: 10,
					chorus: 29,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "lemmbox HD triangle",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 6.1,
					unisonOffset: 6,
					unisonExpression: 2,
					unisonSign: 2,
					isUsingAdvancedLoopControls: true,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 1000,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 250,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "NastyFM2",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 1.4142 },
					],
					effects: ["transition type", "bitcrusher", "chorus", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					panDelay: 10,
					chorus: 43,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3←4",
					feedbackType: "1→2",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "0.25×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 9, waveform: "pulse width", pulseWidth: 7 },
						{ frequency: "1×", amplitude: 6, waveform: "pulse width", pulseWidth: 7 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Distortion Sine",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 16000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2 },
						{ type: "peak", cutoffHz: 8000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 16000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2 },
						{ type: "peak", cutoffHz: 8000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 1.4142 },
					],
					eqSubFilters1: [],
					effects: [
						"transition type",
						"granular",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					granular: 1,
					grainSize: 49,
					grainAmounts: 5,
					grainRange: 40,
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 14,
					reverb: 42,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "screeching chip",
				generalMidi: false,
				tags: ["chip", "chipwave", "thatbeepboxguy"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 16000, linearGain: 2 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 16000, linearGain: 2 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 1.4142 },
					],
					effects: [
						"transition type",
						"detune",
						"vibrato",
						"granular",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 40,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					granular: 2,
					grainSize: 49,
					grainAmounts: 5,
					grainRange: 40,
					distortion: 57,
					aliases: true,
					panDelay: 10,
					chorus: 57,
					echoSustain: 71,
					echoDelayBeats: 0.75,
					reverb: 45,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "lemmbox HD sawtooth",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 512,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "unison",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							steps: 2,
							seed: 2,
							waveform: 0,
						},
					],
				},
			},
			{
				name: "supersaw of power",
				generalMidi: false,
				tags: ["chip", "customchip", "thatbeepboxguy"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["granular", "distortion", "chorus", "ring mod"],
					granular: 1,
					grainSize: 49,
					grainAmounts: 5,
					grainRange: 40,
					ringMod: 29,
					ringModHz: 51,
					ringModWaveformIndex: 3,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					distortion: 43,
					aliases: true,
					panDelay: 10,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -23,
						"4": -23,
						"5": -23,
						"6": -22,
						"7": -22,
						"8": -22,
						"9": -21,
						"10": -21,
						"11": -21,
						"12": -20,
						"13": -20,
						"14": -20,
						"15": -19,
						"16": -19,
						"17": -19,
						"18": -18,
						"19": -18,
						"20": -18,
						"21": -17,
						"22": -17,
						"23": -17,
						"24": -16,
						"25": -16,
						"26": -16,
						"27": -15,
						"28": -15,
						"29": -15,
						"30": -14,
						"31": -14,
						"32": -14,
						"33": -13,
						"34": -13,
						"35": -13,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 23,
						"40": 23,
						"41": 23,
						"42": 22,
						"43": 22,
						"44": 22,
						"45": 21,
						"46": 21,
						"47": 21,
						"48": 20,
						"49": 20,
						"50": 20,
						"51": 19,
						"52": 19,
						"53": 19,
						"54": 18,
						"55": 18,
						"56": 18,
						"57": 17,
						"58": 17,
						"59": 17,
						"60": 16,
						"61": 16,
						"62": 15,
						"63": 15,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Deformed FM Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 16000,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 16000,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 1 },
					],
					eqSubFilters1: [],
					effects: ["note filter", "distortion", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Deformed FM Lead",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 16000,
							linearGain: 1.4142,
						},
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 16000,
							linearGain: 1.4142,
						},
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.3536 },
					],
					effects: ["transition type", "granular", "distortion", "chorus", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					granular: 1,
					grainSize: 47,
					grainAmounts: 5,
					grainRange: 31,
					distortion: 100,
					aliases: false,
					panDelay: 10,
					chorus: 29,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1→2",
					feedbackAmplitude: 13,
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 6, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Clicky Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "thatbeepboxguy"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["distortion"],
					distortion: 100,
					aliases: true,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			// { name: "", generalMidi: false, tags:["", "thatbeepboxguy"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "thatbeepboxguy"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "thatbeepboxguy"], settings: {} },
		]),
	},
	{
		name: "HoneykitKD's Presets",
		presets: toNameMap([
			{
				name: "Resonant Lead",
				generalMidi: false,
				tags: ["chip", "customchip", "honeykitkd", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 5,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.25 }],
					effects: ["transition type", "vibrato", "chorus", "echo", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 0.667,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "brucebox isolated spiky",
					unison: "octave",
					customChipWave: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": -2,
						"4": 0,
						"5": -9,
						"6": 0,
						"7": 0,
						"8": -5,
						"9": 1,
						"10": 4,
						"11": 1,
						"12": -8,
						"13": 0,
						"14": -1,
						"15": 22,
						"16": 0,
						"17": 0,
						"18": -23,
						"19": 4,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": -2,
						"24": 0,
						"25": -16,
						"26": -15,
						"27": -5,
						"28": 0,
						"29": -23,
						"30": -1,
						"31": -5,
						"32": -11,
						"33": -1,
						"34": 0,
						"35": 0,
						"36": 14,
						"37": -4,
						"38": 0,
						"39": -1,
						"40": -1,
						"41": -4,
						"42": 0,
						"43": -1,
						"44": 0,
						"45": 1,
						"46": 0,
						"47": -1,
						"48": -1,
						"49": -6,
						"50": -5,
						"51": -1,
						"52": -2,
						"53": -1,
						"54": 8,
						"55": 4,
						"56": 0,
						"57": -24,
						"58": -1,
						"59": 15,
						"60": 13,
						"61": 9,
						"62": -2,
						"63": -1,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Dusty Mumble",
				generalMidi: false,
				tags: ["fm", "fm6op", "honeykitkd"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
					],
					effects: ["pitch shift", "vibrato", "note filter", "bitcrusher", "reverb"],
					pitchShiftSemitones: 13,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 86,
					panDelay: 10,
					reverb: 23,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					algorithm: "1←(2 (3 (4 (5 (6",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "13×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 13, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 11, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 12, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "19×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 20,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 0.8,
							discrete: false,
							index: 5,
						},
						{
							target: "feedbackAmplitude",
							envelope: "linear",
							inverse: true,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 0.6,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Midnight Lead",
				generalMidi: false,
				tags: ["supersaw", "honeykitkd"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "peak", cutoffHz: 353.55, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 353.55, linearGain: 0.25 }],
					effects: ["vibrato", "note filter", "echo"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 }],
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 1.417,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 100,
					spread: 75,
					shape: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 18,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 0.7,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Raspy Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "honeykitkd"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
					],
					effects: ["transition type", "vibrato", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0.0575,
					fadeOutTicks: -3,
					algorithm: "1 2 (3 4 5)←6",
					feedbackType: "1→2",
					feedbackAmplitude: 0,
					operators: [
						{
							frequency: "0.12×",
							amplitude: 14,
							waveform: "pulse width",
							pulseWidth: 7,
						},
						{
							frequency: "0.12×",
							amplitude: 10,
							waveform: "quasi-sine",
							pulseWidth: 5,
						},
						{
							frequency: "0.25×",
							amplitude: 13,
							waveform: "pulse width",
							pulseWidth: 5,
						},
						{ frequency: "0.5×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 10, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "quasi-sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 0.8,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 0.8,
							discrete: false,
							index: 5,
						},
					],
				},
			},
			{
				name: "Crystallized Pad",
				generalMidi: false,
				tags: ["harmonics", "honeykitkd"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["vibrato", "note filter", "distortion", "echo", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.125 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.125 },
					],
					distortion: 57,
					aliases: false,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 10,
					fadeInSeconds: 0.0938,
					fadeOutTicks: -24,
					harmonics: [
						57, 71, 0, 86, 0, 0, 0, 71, 86, 86, 14, 43, 0, 0, 0, 57, 14, 100, 0, 43, 0,
						0, 100, 0, 0, 14, 0, 0,
					],
					unison: "shimmer",
					envelopes: [
						{
							target: "distortion",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 0.07,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 5.5,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "RWEEEEE Pad",
				generalMidi: false,
				tags: ["chip", "chipwave", "honeykitkd"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 0.125 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 0.125 },
					],
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 11.3137 }],
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					wave: "todbox 1/3 pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 3,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 17,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Sunshine Pad",
				generalMidi: false,
				tags: ["pwm", "honeykitkd"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "peak", cutoffHz: 420.45, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 420.45, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 1.4142,
						},
					],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: true,
							perEnvelopeSpeed: 19,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Choppy Synth",
				generalMidi: false,
				tags: ["pickedstring", "honeykitkd"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 105.11,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 105.11,
							linearGain: 0.25,
						},
					],
					effects: ["note filter", "granular", "distortion", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
					],
					granular: 4,
					grainSize: 37,
					grainAmounts: 2,
					grainRange: 20,
					distortion: 86,
					aliases: false,
					panDelay: 10,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						0, 0, 100, 100, 43, 0, 0, 0, 43, 0, 100, 0, 14, 57, 0, 0, 29, 43, 0, 0, 14,
						0, 71, 0, 0, 0, 0, 0,
					],
					unison: "none",
					stringSustain: 21,
					envelopes: [
						{
							target: "distortion",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 4.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Oooohh Spookyyy",
				generalMidi: false,
				tags: ["fm", "fm6op", "honeykitkd"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["vibrato"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					algorithm: "1 (2 3)←5←6 4",
					feedbackType: "1→3",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{
							frequency: "0.25×",
							amplitude: 13,
							waveform: "pulse width",
							pulseWidth: 4,
						},
						{ frequency: "0.25×", amplitude: 13, waveform: "ramp", pulseWidth: 5 },
						{
							frequency: "0.12×",
							amplitude: 6,
							waveform: "pulse width",
							pulseWidth: 9,
						},
						{ frequency: "0.75×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorFrequency",
							envelope: "fall",
							inverse: true,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 1.7,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "Moonlight Riser",
				generalMidi: false,
				tags: ["spectrum", "honeykitkd"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 0.125,
						},
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 0.125,
						},
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.25 },
					],
					effects: ["transition type", "note filter", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: true,
					noteSimpleCut: 6,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 2196.8, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2196.8, linearGain: 1 }],
					panDelay: 0,
					reverb: 10,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					spectrum: [
						86, 29, 0, 0, 14, 0, 14, 86, 0, 0, 0, 86, 0, 29, 100, 0, 86, 0, 86, 29, 0,
						100, 29, 0, 0, 0, 14, 0, 0, 14,
					],
					unison: "rising",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 1.3333,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Moonlight Organ",
				generalMidi: false,
				tags: ["pickedstring", "honeykitkd"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 1 }],
					effects: ["echo"],
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 1.333,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					harmonics: [
						100, 86, 29, 86, 14, 29, 14, 43, 0, 14, 0, 14, 29, 14, 14, 43, 29, 14, 29,
						14, 29, 0, 14, 43, 29, 29, 57, 29,
					],
					unison: "bowed",
					stringSustain: 64,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 6.5,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 1.4,
							discrete: false,
						},
					],
				},
			},
			{
				name: "wawa",
				generalMidi: false,
				tags: ["spectrum", "honeykitkd"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 1 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 2 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 1 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 2 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2.8284 },
					],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 8 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 8 }],
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					spectrum: [
						100, 0, 14, 0, 14, 0, 0, 100, 0, 29, 0, 86, 0, 14, 57, 29, 86, 14, 100, 0,
						43, 86, 14, 14, 0, 0, 14, 29, 14, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 0.4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 7.5,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 0.7,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Moonlight Pad",
				generalMidi: false,
				tags: ["spectrum", "honeykitkd"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 2,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 840.9, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 840.9, linearGain: 2.8284 }],
					panDelay: 0,
					reverb: 26,
					fadeInSeconds: 0.1138,
					fadeOutTicks: 48,
					spectrum: [
						100, 14, 14, 0, 14, 29, 0, 86, 0, 0, 29, 100, 43, 0, 57, 14, 100, 0, 86, 0,
						0, 71, 0, 14, 29, 0, 0, 29, 43, 29,
					],
					unison: "octave",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Synth Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "honeykitkd"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 0.5,
						},
					],
					effects: ["transition type", "bitcrusher", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 71,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					algorithm: "1 2 3←4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "~1×", amplitude: 9, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 9, waveform: "trapezoid", pulseWidth: 5 },
						{
							frequency: "0.5×",
							amplitude: 13,
							waveform: "pulse width",
							pulseWidth: 1,
						},
						{ frequency: "0.75×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 5.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Flashlight Pulse",
				generalMidi: false,
				tags: ["pwm", "honeykitkd"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 0.3536,
						},
					],
					effects: ["note filter", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 5.6569 }],
					panDelay: 0,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							waveform: 2,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Vibrant Pony",
				generalMidi: false,
				tags: ["harmonics", "honeykitkd"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					effects: ["transition type", "granular", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					granular: 3,
					grainSize: 36,
					grainAmounts: 7,
					grainRange: 13,
					panDelay: 0,
					echoSustain: 29,
					echoDelayBeats: 0.333,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					harmonics: [
						86, 100, 71, 100, 43, 14, 0, 0, 86, 0, 71, 86, 43, 14, 14, 43, 0, 29, 14,
						14, 0, 0, 0, 0, 14, 14, 14, 14,
					],
					unison: "none",
					envelopes: [
						{
							target: "reverb",
							envelope: "wibble",
							inverse: true,
							perEnvelopeSpeed: 4.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "reverb",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 2.75,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Pulsing Light",
				generalMidi: false,
				tags: ["pickedstring", "honeykitkd"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 1.4142,
						},
					],
					effects: ["note filter", "bitcrusher", "chorus", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 }],
					bitcrusherOctave: 6,
					bitcrusherQuantization: 57,
					panDelay: 0,
					chorus: 86,
					echoSustain: 57,
					echoDelayBeats: 1.167,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					harmonics: [
						100, 57, 43, 0, 14, 29, 14, 43, 57, 57, 43, 86, 86, 14, 29, 29, 14, 14, 43,
						0, 29, 29, 29, 0, 14, 14, 14, 0,
					],
					unison: "recurve",
					stringSustain: 79,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "flare",
							inverse: true,
							perEnvelopeSpeed: 1.3333,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.8,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Boop Keys",
				generalMidi: false,
				tags: ["harmonics", "honeykitkd"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 11.3137,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 11.3137,
						},
					],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						100, 14, 43, 14, 14, 29, 43, 43, 14, 0, 14, 14, 29, 0, 29, 29, 0, 14, 0, 0,
						14, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "spinner",
					envelopes: [],
				},
			},
			{
				name: "Shy Lead",
				generalMidi: false,
				tags: ["pwm", "honeykitkd"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 8 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 8 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.5 },
					],
					effects: ["transition type", "chord type", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 0,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 32,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "wibble",
							inverse: true,
							perEnvelopeSpeed: 6.5,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1.6,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Rusty Keys",
				generalMidi: false,
				tags: ["chip", "customchip", "honeykitkd", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.7071,
						},
					],
					effects: ["vibrato", "note filter", "distortion"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
					],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 12,
					wave: "1/4 pulse",
					unison: "none",
					customChipWave: {
						"0": -23,
						"1": -21,
						"2": -18,
						"3": -16,
						"4": -13,
						"5": -11,
						"6": -8,
						"7": -6,
						"8": -3,
						"9": 0,
						"10": 3,
						"11": 6,
						"12": 10,
						"13": 13,
						"14": 16,
						"15": 19,
						"16": 23,
						"17": -22,
						"18": -18,
						"19": -15,
						"20": -11,
						"21": -7,
						"22": -4,
						"23": 0,
						"24": 3,
						"25": 7,
						"26": 11,
						"27": 14,
						"28": 18,
						"29": 21,
						"30": -23,
						"31": -20,
						"32": -17,
						"33": -14,
						"34": -10,
						"35": -7,
						"36": -4,
						"37": -1,
						"38": 2,
						"39": 4,
						"40": 7,
						"41": 10,
						"42": 12,
						"43": 15,
						"44": 17,
						"45": 19,
						"46": 21,
						"47": 23,
						"48": -23,
						"49": -21,
						"50": -20,
						"51": -18,
						"52": -17,
						"53": -15,
						"54": -14,
						"55": -13,
						"56": -12,
						"57": -11,
						"58": -10,
						"59": -9,
						"60": -8,
						"61": -8,
						"62": -7,
						"63": -7,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Growling Ghoul",
				generalMidi: false,
				tags: ["fm", "fm6op", "honeykitkd"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.125 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.125 }],
					effects: ["vibrato", "granular"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					granular: 4,
					grainSize: 50,
					grainAmounts: 3,
					grainRange: 40,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←(3 4)←5 2←6",
					feedbackType: "1→4",
					feedbackAmplitude: 12,
					operators: [
						{ frequency: "~2×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 1, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "0.75×",
							amplitude: 7,
							waveform: "pulse width",
							pulseWidth: 5,
						},
					],
					envelopes: [
						{
							target: "grainSize",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 5.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "operatorFrequency",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 0.4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "Dreary Synth",
				generalMidi: false,
				tags: ["chip", "chipwave", "honeykitkd", "featured"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 1.4142,
						},
					],
					effects: ["vibrato", "note filter", "granular", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 }],
					granular: 3,
					grainSize: 43,
					grainAmounts: 4,
					grainRange: 7,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sandbox r-sawtooth",
					unison: "hecking gosh",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 0.8,
							discrete: false,
						},
						{
							target: "grainRange",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0.3,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Crispy Computer",
				generalMidi: false,
				tags: ["fm", "fm4op", "honeykitkd"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 3363.59, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 3363.59, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 11.3137 },
					],
					effects: ["vibrato", "note filter", "bitcrusher"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 5.6569 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 57,
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 6,
					algorithm: "1 2 3←4",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.25×", amplitude: 11, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 3, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "pulse width", pulseWidth: 2 },
						{ frequency: "1×", amplitude: 0, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Sploshy Detune",
				generalMidi: false,
				tags: ["chip", "customchip", "honeykitkd"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.7071,
						},
					],
					effects: ["chord type", "vibrato", "note filter", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 8 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 8 }],
					panDelay: 0,
					echoSustain: 71,
					echoDelayBeats: 0.917,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "wackybox buzz wave",
					unison: "rising",
					customChipWave: {
						"0": 17,
						"1": 17,
						"2": 17,
						"3": 16,
						"4": 15,
						"5": 14,
						"6": 13,
						"7": 12,
						"8": 10,
						"9": 9,
						"10": 7,
						"11": 5,
						"12": 3,
						"13": 2,
						"14": 0,
						"15": -2,
						"16": -4,
						"17": -5,
						"18": -7,
						"19": -8,
						"20": -9,
						"21": -10,
						"22": -11,
						"23": -12,
						"24": -12,
						"25": -12,
						"26": -12,
						"27": -12,
						"28": -11,
						"29": -10,
						"30": -9,
						"31": -8,
						"32": -6,
						"33": -4,
						"34": -2,
						"35": 0,
						"36": 2,
						"37": 5,
						"38": 8,
						"39": 11,
						"40": 14,
						"41": 17,
						"42": 20,
						"43": 23,
						"44": -22,
						"45": -19,
						"46": -16,
						"47": -13,
						"48": -10,
						"49": -7,
						"50": -5,
						"51": -2,
						"52": 0,
						"53": 2,
						"54": 4,
						"55": 6,
						"56": 7,
						"57": 8,
						"58": 9,
						"59": 10,
						"60": 10,
						"61": 10,
						"62": 10,
						"63": 10,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 4.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1.9,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Cheesy Snare",
				generalMidi: false,
				tags: ["fm", "fm6op", "honeykitkd", "snare"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 1414.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 5.6569 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 1414.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 5.6569 },
					],
					eqSubFilters1: [],
					effects: ["detune", "note filter", "distortion"],
					detuneCents: 200,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 5.6569 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 5.6569 },
					],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					algorithm: "1 2←5 (3 4)←6",
					feedbackType: "1→2→3→4→5→6",
					feedbackAmplitude: 14,
					operators: [
						{ frequency: "0.5×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "100×", amplitude: 5, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "distortion",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "distortion",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Bright Fuzzy Keys",
				generalMidi: false,
				tags: ["chip", "chipwave", "honeykitkd"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 250, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 250, linearGain: 2 },
					],
					effects: ["vibrato", "note filter", "ring mod"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 }],
					ringMod: 14,
					ringModHz: 41,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "modbox sunsoft bass",
					unison: "inject",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 1.3,
							perEnvelopeUpperBound: 1.7,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Digital Bell",
				generalMidi: false,
				tags: ["fm", "fm6op", "honeykitkd"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.7071,
						},
					],
					effects: ["chord type", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 10,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1←5 (2 3 4)←6",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "17×", amplitude: 14, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 13, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 0, waveform: "pulse width", pulseWidth: 8 },
						{ frequency: "9×", amplitude: 10, waveform: "pulse width", pulseWidth: 6 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 0.2,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 2.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "feedbackAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 1.1,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Scratchy Pad",
				generalMidi: false,
				tags: ["fm", "fm4op", "honeykitkd"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
					],
					effects: ["chord type", "bitcrusher", "echo"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 71,
					panDelay: 10,
					echoSustain: 29,
					echoDelayBeats: 1.417,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←2←(3 4)",
					feedbackType: "(1 2 3)→4",
					feedbackAmplitude: 13,
					operators: [
						{ frequency: "1×", amplitude: 9, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 3, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 7, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "bitcrusherQuantization",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "wibble",
							inverse: true,
							perEnvelopeSpeed: 0.03,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorFrequency",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 0.8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Detuned Vibe",
				generalMidi: false,
				tags: ["pickedstring", "honeykitkd"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.3536 }],
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 5.6569 }],
					panDelay: 10,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					harmonics: [
						86, 71, 14, 43, 0, 57, 71, 14, 100, 0, 57, 0, 0, 57, 14, 71, 0, 0, 57, 57,
						0, 29, 43, 43, 29, 43, 14, 43,
					],
					unison: "vibrate",
					stringSustain: 57,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 1.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "reverb",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Sunshine Bell",
				generalMidi: false,
				tags: ["pickedstring", "honeykitkd"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 8 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 19027.31, linearGain: 0.1768 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 8 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 19027.31, linearGain: 0.1768 },
					],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2.8284 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					harmonics: [
						0, 0, 57, 71, 29, 86, 29, 100, 0, 29, 0, 0, 0, 0, 0, 0, 43, 0, 43, 29, 0, 0,
						0, 100, 0, 0, 0, 86,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 1.5,
							perEnvelopeUpperBound: 1.7,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Mythical Bells",
				generalMidi: false,
				tags: ["harmonics", "honeykitkd"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 2948.87, linearGain: 2 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["echo"],
					panDelay: 0,
					echoSustain: 86,
					echoDelayBeats: 1.167,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					harmonics: [
						86, 43, 0, 100, 29, 43, 0, 0, 14, 71, 43, 0, 0, 71, 0, 0, 0, 86, 0, 14, 0,
						57, 0, 0, 86, 0, 0, 0,
					],
					unison: "hum",
					envelopes: [],
				},
			},
			{
				name: "Sunshine Synth",
				generalMidi: false,
				tags: ["chip", "chipwave", "honeykitkd"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 2948.87, linearGain: 2 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chord type", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 0,
					reverb: 97,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "triangle",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "After Hours Chords",
				generalMidi: false,
				tags: ["chip", "chipwave", "honeykitkd"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1000, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1000, linearGain: 4 },
					],
					effects: ["pitch shift", "reverb"],
					pitchShiftSemitones: 11,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "trapezoid",
					unison: "hum",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "honeykitkd"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "honeykitkd"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "honeykitkd"], settings: {} },
		]),
	},
	{
		name: "Calamity's Presets",
		presets: toNameMap([
			{
				name: "growly bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "note filter", "distortion", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2 },
					],
					distortion: 57,
					aliases: false,
					pan: 0,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "twang 1", index: 3 },
						{
							target: "operatorAmplitude",
							envelope: "note size",
							index: 3,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "satin growl drone",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
					],
					eqSubFilters1: [],
					eqSubFilters2: [],
					eqSubFilters3: [],
					eqSubFilters4: [],
					eqSubFilters5: [],
					eqSubFilters6: [],
					eqSubFilters7: [],
					eqSubFilters8: [],
					eqSubFilters9: [],
					effects: [
						"panning",
						"chord type",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
					],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "custom",
					vibratoDepth: 0.2,
					vibratoDelay: 12,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.125 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.125 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 },
					],
					distortion: 57,
					aliases: false,
					pan: 0,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "note size", index: 3 },
						{
							target: "operatorAmplitude",
							envelope: "note size",
							index: 5,
						},
						{ target: "noteFilterAllFreqs", envelope: "note size" },
					],
					isDrum: false,
				},
			},
			{
				name: "race car pad",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 500, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 500, linearGain: 0.3536 }],
					effects: [
						"panning",
						"chord type",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"echo",
					],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "custom",
					vibratoDepth: 0.16,
					vibratoDelay: 12,
					vibratoSpeed: 2,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.25 }],
					distortion: 0,
					aliases: false,
					pan: 0,
					panDelay: 10,
					chorus: 43,
					echoSustain: 14,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0.1138,
					fadeOutTicks: 72,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "7×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "twang -1", index: 0 },
						{ target: "operatorFrequency", envelope: "decay 3", index: 1 },
						{ target: "operatorFrequency", envelope: "decay 1", index: 2 },
						{ target: "operatorFrequency", envelope: "decay 3", index: 3 },
						{ target: "operatorFrequency", envelope: "decay 1", index: 4 },
						{ target: "operatorFrequency", envelope: "decay 3", index: 5 },
						{ target: "noteVolume", envelope: "swell 2" },
						{ target: "noteFilterFreq", envelope: "swell 3", index: 0 },
						{ target: "feedbackAmplitude", envelope: "wibble 3" },
						{ target: "operatorAmplitude", envelope: "swell 2", index: 0 },
					],
					isDrum: false,
				},
			},
			{
				name: "victory edm snare",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity", "snare"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "peak", cutoffHz: 3363.59, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 3363.59, linearGain: 0.25 }],
					effects: ["panning", "chord type", "note filter", "distortion", "chorus"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					distortion: 71,
					aliases: false,
					pan: 0,
					panDelay: 10,
					chorus: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 9,
					customAlgorithm: { mods: [[3], [4], [], [5], [6], []], carrierCount: 2 },
					customFeedback: { mods: [[], [5, 5], [], [2], [4, 2], [5, 2]] },
					operators: [
						{ frequency: "50×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "twang -1", index: 0 },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 0 },
						{ target: "operatorAmplitude", envelope: "flare 3", index: 1 },
						{ target: "operatorFrequency", envelope: "twang -1", index: 0 },
						{ target: "noteVolume", envelope: "punch" },
						{ target: "noteVolume", envelope: "twang 1" },
						{ target: "noteVolume", envelope: "twang 2" },
					],
					isDrum: false,
				},
			},
			{
				name: "squary pan flute",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity", "featured"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 0,
					chorus: 71,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 45,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.5×", amplitude: 7, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "pluck away",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "chord type", "note filter", "chorus", "echo"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.25,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.25,
						},
					],
					pan: 0,
					panDelay: 10,
					chorus: 43,
					echoSustain: 29,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "Custom",
					feedbackType: "1→5 2→6 3→4",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[3, 5], [5], [4], [], [6], []], carrierCount: 2 },
					operators: [
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "none", index: 0 },
						{ target: "operatorAmplitude", envelope: "none", index: 0 },
						{ target: "operatorFrequency", envelope: "none", index: 2 },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 2 },
						{ target: "operatorFrequency", envelope: "none", index: 3 },
						{ target: "operatorAmplitude", envelope: "none", index: 3 },
					],
					isDrum: false,
				},
			},
			{
				name: "cavern chip",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"panning",
						"chord type",
						"vibrato",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "custom",
					vibratoDepth: 0.36,
					vibratoDelay: 26,
					vibratoSpeed: 7,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					pan: 0,
					panDelay: 10,
					chorus: 43,
					echoSustain: 71,
					echoDelayBeats: 0.667,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1→5 2→6 3→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "none", index: 0 },
						{ target: "operatorAmplitude", envelope: "none", index: 0 },
						{ target: "operatorFrequency", envelope: "none", index: 2 },
						{ target: "operatorAmplitude", envelope: "none", index: 2 },
						{ target: "operatorFrequency", envelope: "none", index: 3 },
						{ target: "operatorAmplitude", envelope: "rise 2", index: 3 },
					],
					isDrum: false,
				},
			},
			{
				name: "noise citar growl",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					eqSubFilters1: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 4 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 0.125 },
					],
					eqSubFilters2: [
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 0.125 },
					],
					eqSubFilters3: [],
					effects: ["panning", "chord type", "note filter", "distortion", "chorus"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 500, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 88.39,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 500, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 88.39,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
					],
					distortion: 86,
					aliases: false,
					pan: 0,
					panDelay: 10,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "8×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~20×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "note size" },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 2,
						},
						{ target: "operatorAmplitude", envelope: "note size", index: 3 },
					],
					isDrum: false,
				},
			},
			{
				name: "metallophone fr",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 1414.21, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 1414.21, linearGain: 0.0884 }],
					effects: ["panning", "chord type", "note filter", "chorus"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 }],
					pan: 0,
					panDelay: 10,
					chorus: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "none", index: 0 },
						{ target: "operatorAmplitude", envelope: "none", index: 0 },
						{ target: "operatorFrequency", envelope: "none", index: 2 },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 2 },
						{ target: "operatorFrequency", envelope: "none", index: 3 },
						{ target: "operatorAmplitude", envelope: "none", index: 3 },
					],
					isDrum: false,
				},
			},
			{
				name: "envelope bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "chord type", "note filter", "chorus"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 11.3137 }],
					pan: 0,
					panDelay: 10,
					chorus: 57,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang 1", index: 2 },
						{
							target: "noteFilterAllFreqs",
							envelope: "decay 2",
						},
					],
					isDrum: false,
				},
			},
			{
				name: "mystery guitar",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity", "featured"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.7071 }],
					effects: ["panning", "chord type", "note filter", "chorus", "echo"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					pan: 0,
					panDelay: 10,
					chorus: 57,
					echoSustain: 29,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "none", index: 0 },
						{ target: "operatorAmplitude", envelope: "none", index: 0 },
						{ target: "operatorFrequency", envelope: "none", index: 2 },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 2 },
						{ target: "operatorFrequency", envelope: "none", index: 3 },
						{ target: "operatorAmplitude", envelope: "none", index: 3 },
					],
					isDrum: false,
				},
			},
			{
				name: "FM noise hat",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 1681.79, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 1681.79, linearGain: 0.0884 }],
					effects: ["panning", "chord type", "note filter", "chorus", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					pan: 0,
					panDelay: 10,
					chorus: 29,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1→2→3→4→5→6→1",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "10×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "50×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "blip 1", index: 0 },
						{
							target: "feedbackAmplitude",
							envelope: "decay 2",
						},
						{ target: "operatorAmplitude", envelope: "linear-1", index: 1 },
					],
					isDrum: false,
				},
			},
			{
				name: "Imagination Bell",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity", "featured"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"panning",
						"chord type",
						"pitch shift",
						"detune",
						"note filter",
						"chorus",
						"echo",
					],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 0,
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					pan: 0,
					panDelay: 10,
					chorus: 71,
					echoSustain: 71,
					echoDelayBeats: 0.417,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "4⟲",
					feedbackAmplitude: 14,
					operators: [
						{ frequency: "3.5×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "12×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang 3", index: 2 },
						{ target: "operatorAmplitude", envelope: "twang 2", index: 3 },
						{ target: "feedbackAmplitude", envelope: "swell 3" },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 4 },
						{ target: "operatorAmplitude", envelope: "twang 3", index: 5 },
						{ target: "none", envelope: "none" },
					],
					isDrum: false,
				},
			},
			{
				name: "dyuw lead",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.5 }],
					effects: [
						"panning",
						"chord type",
						"pitch shift",
						"vibrato",
						"note filter",
						"chorus",
						"reverb",
					],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 12,
					vibrato: "custom",
					vibratoDepth: 0.44,
					vibratoDelay: 14,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					pan: 0,
					panDelay: 10,
					chorus: 43,
					reverb: 26,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "none", index: 0 },
						{ target: "operatorFrequency", envelope: "decay 1", index: 2 },
						{ target: "operatorAmplitude", envelope: "twang -1", index: 2 },
						{ target: "none", envelope: "none" },
					],
					isDrum: false,
				},
			},
			{
				name: "FM octave bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 840.9, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 840.9, linearGain: 0.7071 }],
					effects: ["panning", "chord type", "pitch shift", "note filter", "chorus"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					pan: 0,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "wha pad wha",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "peak", cutoffHz: 62.5, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 125, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 62.5, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 125, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2 },
					],
					effects: ["panning", "transition type", "chord type", "note filter", "chorus"],
					transition: "slide",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 2 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 2 }],
					pan: 0,
					panDelay: 10,
					chorus: 86,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "3×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "none", index: 0 },
						{ target: "operatorAmplitude", envelope: "none", index: 0 },
						{ target: "operatorFrequency", envelope: "none", index: 2 },
						{ target: "operatorAmplitude", envelope: "tremolo6", index: 2 },
						{ target: "operatorFrequency", envelope: "none", index: 3 },
						{ target: "operatorAmplitude", envelope: "swell 3", index: 3 },
						{ target: "noteFilterFreq", envelope: "swell 3", index: 0 },
					],
					isDrum: false,
				},
			},
			{
				name: "e piano twinkle",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.7071 }],
					effects: ["panning", "chord type", "note filter", "chorus"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					pan: 0,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "linear-2", index: 2 }],
					isDrum: false,
				},
			},
			{
				name: "bwow strings",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "chord type", "note filter", "chorus"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 }],
					pan: 0,
					panDelay: 10,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "none", index: 2 },
						{ target: "operatorAmplitude", envelope: "swell 2", index: 2 },
						{ target: "operatorAmplitude", envelope: "wibble 3", index: 3 },
						{ target: "none", envelope: "none" },
					],
					isDrum: false,
				},
			},
			{
				name: "reso mid lead",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.1768 },
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.1768 },
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 },
					],
					effects: ["panning", "pitch shift", "note filter", "echo"],
					pitchShiftSemitones: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					pan: 0,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2←4 3←(5 6)",
					feedbackType: "2→3",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 1, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 2, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang 1", index: 0 },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 1,
						},
						{ target: "operatorAmplitude", envelope: "linear-2", index: 2 },
					],
					isDrum: false,
				},
			},
			{
				name: "nostalgic piano pad",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
					],
					effects: ["panning", "chord type", "vibrato", "note filter", "chorus"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "custom",
					vibratoDepth: 0.32,
					vibratoDelay: 25,
					vibratoSpeed: 8,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 }],
					pan: 0,
					panDelay: 10,
					chorus: 57,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "none", index: 0 },
						{ target: "operatorAmplitude", envelope: "none", index: 0 },
						{ target: "operatorFrequency", envelope: "none", index: 2 },
						{ target: "operatorAmplitude", envelope: "none", index: 2 },
						{ target: "operatorFrequency", envelope: "none", index: 3 },
						{ target: "operatorAmplitude", envelope: "none", index: 3 },
					],
					isDrum: false,
				},
			},
			{
				name: "bubble keys",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 13454.34, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 13454.34, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.3536,
						},
					],
					effects: ["chorus", "echo"],
					panDelay: 10,
					chorus: 43,
					echoSustain: 43,
					echoDelayBeats: 0.25,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					algorithm: "1 2 3←5 4←6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.5×", amplitude: 0, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 4, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 0, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "12×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "simple chip bass",
				generalMidi: false,
				tags: ["chip", "customchip", "calamity", "chiptune"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					effects: ["panning", "pitch shift", "distortion"],
					pitchShiftSemitones: 24,
					distortion: 29,
					aliases: false,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -17,
						"1": -16,
						"2": -14,
						"3": -13,
						"4": -12,
						"5": -11,
						"6": -9,
						"7": -9,
						"8": -7,
						"9": -7,
						"10": -7,
						"11": -3,
						"12": -1,
						"13": 4,
						"14": 5,
						"15": 7,
						"16": 8,
						"17": 9,
						"18": 10,
						"19": 11,
						"20": 13,
						"21": 13,
						"22": 14,
						"23": 15,
						"24": 16,
						"25": 16,
						"26": 17,
						"27": 18,
						"28": 18,
						"29": 18,
						"30": 18,
						"31": 18,
						"32": 19,
						"33": 19,
						"34": 19,
						"35": 19,
						"36": 19,
						"37": 19,
						"38": 19,
						"39": 19,
						"40": 19,
						"41": 19,
						"42": 18,
						"43": 17,
						"44": 17,
						"45": 16,
						"46": 15,
						"47": 14,
						"48": 13,
						"49": 12,
						"50": 12,
						"51": 11,
						"52": 9,
						"53": 8,
						"54": 7,
						"55": 6,
						"56": 5,
						"57": 4,
						"58": 3,
						"59": 2,
						"60": 0,
						"61": -2,
						"62": -4,
						"63": -6,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "bowed glass cyan",
				generalMidi: false,
				tags: ["fm", "fm4op", "calamity"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.125 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.125 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 0.0884,
						},
					],
					effects: ["panning", "pitch shift", "note filter", "chorus", "reverb"],
					pitchShiftSemitones: 24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.3536 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					pan: 0,
					panDelay: 10,
					chorus: 100,
					reverb: 0,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 48,
					algorithm: "1 2 3 4",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "9×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "e vibraphone",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "peak", cutoffHz: 13454.34, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 13454.34, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.3536,
						},
					],
					effects: ["panning", "chord type", "note filter", "chorus"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					pan: 0,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1 2 3←5 4←6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.5×", amplitude: 0, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 3, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 0, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "12×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "flare 3", index: 5 },
						{ target: "feedbackAmplitude", envelope: "twang 1" },
						{ target: "operatorAmplitude", envelope: "decay 3", index: 1 },
						{ target: "operatorAmplitude", envelope: "decay 3", index: 3 },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 2 },
					],
					isDrum: false,
				},
			},
			{
				name: "twinkle lead",
				generalMidi: false,
				tags: ["harmonics", "calamity"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.125,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.125,
						},
					],
					effects: ["panning", "note filter", "chorus", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					pan: 0,
					panDelay: 0,
					chorus: 43,
					echoSustain: 14,
					echoDelayBeats: 1.25,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -3,
					harmonics: [
						43, 43, 0, 43, 14, 71, 14, 29, 57, 29, 14, 43, 0, 29, 71, 29, 43, 100, 57,
						57, 57, 71, 14, 29, 43, 43, 14, 14,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
					isDrum: false,
				},
			},
			{
				name: "velvet organ",
				generalMidi: false,
				tags: ["fm", "fm4op", "calamity"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					eqSubFilters1: [],
					effects: ["panning", "chorus", "reverb"],
					pan: 0,
					panDelay: 10,
					chorus: 86,
					reverb: 39,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 6,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "80s green keys",
				generalMidi: false,
				tags: ["supersaw", "calamity"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 0.7071,
						},
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 0.7071,
						},
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.25 },
					],
					effects: ["panning", "detune", "chorus", "reverb"],
					detuneCents: 20,
					pan: 0,
					panDelay: 10,
					chorus: 86,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					pulseWidth: 48,
					decimalOffset: 0,
					dynamism: 83,
					spread: 67,
					shape: 83,
					envelopes: [{ target: "detune", envelope: "wibble 3" }],
					isDrum: false,
				},
			},
			{
				name: "Realistic Bells",
				generalMidi: false,
				tags: ["fm", "fm6op", "calamity"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"panning",
						"chord type",
						"pitch shift",
						"detune",
						"note filter",
						"chorus",
						"echo",
					],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 0,
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					pan: 0,
					panDelay: 10,
					chorus: 71,
					echoSustain: 71,
					echoDelayBeats: 0.417,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "4⟲",
					feedbackAmplitude: 14,
					operators: [
						{ frequency: "3.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "12×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang 3", index: 2 },
						{ target: "operatorAmplitude", envelope: "twang 2", index: 3 },
						{ target: "feedbackAmplitude", envelope: "swell 3" },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 4 },
						{ target: "operatorAmplitude", envelope: "twang 3", index: 5 },
						{ target: "none", envelope: "none" },
					],
					isDrum: false,
				},
			},
			// { name: "", generalMidi: false, tags:["", "calamity"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "calamity"], settings: {} },
		]),
	},
	{
		name: "truemori's Presets",
		presets: toNameMap([
			{
				name: "flute staccato",
				generalMidi: false,
				tags: ["pwm", "truemori"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 16000,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 16000,
							linearGain: 0.7071,
						},
					],
					eqSubFilters1: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 0.5,
						},
					],
					eqSubFilters2: [
						{ type: "high-pass", cutoffHz: 2378.41, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 1.4142,
						},
					],
					eqSubFilters3: [],
					effects: [
						"panning",
						"pitch shift",
						"vibrato",
						"note filter",
						"bitcrusher",
						"echo",
						"reverb",
					],
					pitchShiftSemitones: 24,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 1.4142 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					pan: 0,
					panDelay: 10,
					echoSustain: 29,
					echoDelayBeats: 1,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					unison: "shimmer",
					pulseWidth: 47,
					decimalOffset: 0,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "noteVolume",
							envelope: "flare 1",
						},
					],
					isDrum: false,
				},
			},
			{
				name: "ice dude",
				generalMidi: false,
				tags: ["fm", "fm6op", "truemori"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 840.9, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 840.9, linearGain: 0.7071 }],
					effects: [
						"panning",
						"chord type",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 29,
					pan: 0,
					panDelay: 0,
					chorus: 29,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 87,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←4←5 (2 3)←6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "0.25×",
							amplitude: 0,
							waveform: "pulse width",
							pulseWidth: 4,
						},
						{ frequency: "20×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 5, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "flare -1" },
						{
							target: "operatorAmplitude",
							envelope: "flare 1",
							index: 4,
						},
						{ target: "feedbackAmplitude", envelope: "linear-1" },
					],
					isDrum: false,
				},
			},
			{
				name: "alien doodad",
				generalMidi: false,
				tags: ["pickedstring", "truemori"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [{ type: "peak", cutoffHz: 148.65, linearGain: 2 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 148.65, linearGain: 2 }],
					effects: ["panning", "transition type", "bitcrusher", "echo", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					pan: 0,
					panDelay: 0,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 61,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						71, 57, 57, 43, 29, 29, 29, 29, 29, 29, 29, 14, 29, 14, 14, 29, 14, 14, 14,
						14, 14, 14, 14, 14, 14, 0, 0, 14,
					],
					unison: "none",
					stringSustain: 100,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "harsh gunga chip",
				generalMidi: false,
				tags: ["chip", "customchip", "truemori", "chiptune"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.25 }],
					eqSubFilters1: [],
					effects: ["panning", "vibrato"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 7,
						"1": 10,
						"2": 12,
						"3": 14,
						"4": 16,
						"5": 18,
						"6": 20,
						"7": 21,
						"8": 23,
						"9": -24,
						"10": -23,
						"11": -22,
						"12": -21,
						"13": -21,
						"14": -20,
						"15": -20,
						"16": -20,
						"17": -20,
						"18": -20,
						"19": -20,
						"20": -20,
						"21": -21,
						"22": -21,
						"23": -22,
						"24": -22,
						"25": -23,
						"26": -23,
						"27": -24,
						"28": 24,
						"29": 23,
						"30": 22,
						"31": 22,
						"32": 22,
						"33": 21,
						"34": 21,
						"35": 21,
						"36": 21,
						"37": 21,
						"38": 21,
						"39": 21,
						"40": 22,
						"41": 23,
						"42": 23,
						"43": -24,
						"44": -23,
						"45": -21,
						"46": -20,
						"47": -18,
						"48": -17,
						"49": -15,
						"50": -13,
						"51": -10,
						"52": -8,
						"53": -5,
						"54": -3,
						"55": 0,
						"56": 3,
						"57": 6,
						"58": 9,
						"59": 12,
						"60": 15,
						"61": 19,
						"62": 22,
						"63": -23,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "blippy bass",
				generalMidi: false,
				tags: ["pwm", "truemori"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.7071 }],
					effects: ["panning"],
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{ target: "noteVolume", envelope: "twang 2" },
						{
							target: "pulseWidth",
							envelope: "twang 3",
						},
						{ target: "noteVolume", envelope: "twang 2" },
					],
					isDrum: false,
				},
			},
			{
				name: "General Bass Lead",
				generalMidi: false,
				tags: ["chip", "chipwave", "truemori", "featured"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 }],
					effects: ["panning", "chord type", "detune", "bitcrusher", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: -12,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 29,
					pan: 0,
					panDelay: 0,
					chorus: 57,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "modbox 10% pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 10,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteVolume", envelope: "twang 2" }],
					isDrum: false,
				},
			},
			{
				name: "Ghastly Jordan",
				generalMidi: false,
				tags: ["pwm", "truemori"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.7071 }],
					effects: ["panning", "chord type", "echo"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pan: 0,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 47,
					decimalOffset: 0,
					unison: "none",
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "dissonant guy",
				generalMidi: false,
				tags: ["chip", "chipwave", "truemori", "featured"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 9513.66,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 9513.66,
							linearGain: 2.8284,
						},
					],
					effects: ["panning", "transition type", "vibrato", "echo", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					pan: 0,
					panDelay: 0,
					echoSustain: 71,
					echoDelayBeats: 0.833,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "sawtooth",
					unison: "detune",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Harmonic Mario",
				generalMidi: false,
				tags: ["fm", "fm4op", "truemori"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					effects: ["panning", "distortion", "bitcrusher", "echo", "reverb"],
					distortion: 0,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 29,
					pan: 0,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1.083,
					reverb: 48,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1 2←(3 4)",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "4×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 1, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 9, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 0, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Lead Backing",
				generalMidi: false,
				tags: ["pickedstring", "truemori"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "pitch shift", "vibrato"],
					pitchShiftSemitones: 24,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 29, 14, 29, 0, 14, 0, 0, 0, 0, 0, 0, 14, 14, 14, 14, 0, 14, 14, 14, 14,
						14, 29, 14, 14, 14, 14, 29,
					],
					unison: "none",
					stringSustain: 100,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "overclocked vacuum cleaner",
				generalMidi: false,
				tags: ["fm", "fm4op", "truemori"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [
						"panning",
						"chord type",
						"pitch shift",
						"bitcrusher",
						"chorus",
						"echo",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 9,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					pan: 0,
					panDelay: 0,
					chorus: 29,
					echoSustain: 29,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←4",
					feedbackType: "2→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "pitchShift", envelope: "twang 1" },
						{
							target: "feedbackAmplitude",
							envelope: "decay 2",
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Guitar Hero",
				generalMidi: false,
				tags: ["pickedstring", "truemori"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [
						{ type: "peak", cutoffHz: 1189.21, linearGain: 2 },
						{ type: "peak", cutoffHz: 500, linearGain: 2 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1189.21, linearGain: 2 },
						{ type: "peak", cutoffHz: 500, linearGain: 2 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.7071 },
					],
					effects: [
						"panning",
						"chord type",
						"note filter",
						"distortion",
						"echo",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2.8284 },
						{
							type: "low-pass",
							cutoffHz: 19027.31,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2.8284 },
						{
							type: "low-pass",
							cutoffHz: 19027.31,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
					],
					distortion: 100,
					aliases: false,
					pan: 0,
					panDelay: 10,
					echoSustain: 0,
					echoDelayBeats: 0.083,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						86, 100, 100, 86, 86, 86, 86, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 57,
						57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
					],
					unison: "none",
					stringSustain: 79,
					envelopes: [{ target: "noteFilterFreq", envelope: "note size", index: 1 }],
					isDrum: false,
				},
			},
			{
				name: "cool blue chirp",
				generalMidi: false,
				tags: ["fm", "fm6op", "truemori"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 0.1768,
						},
					],
					effects: ["panning", "transition type", "chord type", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pan: 0,
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 1.25,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "5⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2], [3], [4], [5], [6], []], carrierCount: 1 },
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 5, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 0, waveform: "quasi-sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Pluck of Joy",
				generalMidi: false,
				tags: ["fm", "fm4op", "truemori"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 500, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 500, linearGain: 0.7071 }],
					effects: ["panning", "chord type", "vibrato"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Big Glaggle Lead",
				generalMidi: false,
				tags: ["supersaw", "truemori"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 1 },
					],
					effects: [
						"panning",
						"transition type",
						"detune",
						"vibrato",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					detuneCents: 12,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 14,
					pan: 0,
					panDelay: 0,
					chorus: 14,
					echoSustain: 29,
					echoDelayBeats: 1,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 24,
					decimalOffset: 0,
					dynamism: 17,
					spread: 83,
					shape: 33,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "broken robot",
				generalMidi: false,
				tags: ["fm", "fm4op", "truemori"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 0.7071,
						},
					],
					effects: ["panning", "chord type", "distortion", "chorus", "echo"],
					chord: "custom interval",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					distortion: 0,
					aliases: false,
					pan: 0,
					panDelay: 0,
					chorus: 0,
					echoSustain: 0,
					echoDelayBeats: 1.083,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3)←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			// { name: "", generalMidi: false, tags:["", "truemori"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "truemori"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "truemori"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "truemori"], settings: {} },
		]),
	},
	{
		name: "The TuneCrusher's Presets",
		presets: toNameMap([
			{
				name: "Blip Pulse",
				generalMidi: false,
				tags: ["pwm", "thetunecrusher"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["panning", "pitch shift", "chorus", "echo"],
					pitchShiftSemitones: 0,
					pan: 0,
					panDelay: 10,
					chorus: 29,
					echoSustain: 57,
					echoDelayBeats: 0.333,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					pulseWidth: 25,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pitchShift",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Distorted Saw 1",
				generalMidi: false,
				tags: ["supersaw", "thetunecrusher"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1.4142 }],
					effects: [
						"panning",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"reverb",
					],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 1.4142,
						},
					],
					distortion: 100,
					aliases: true,
					pan: 0,
					panDelay: 0,
					chorus: 57,
					reverb: 65,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 6,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 17,
					spread: 25,
					shape: 100,
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
						{
							target: "vibratoDepth",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: true,
						},
						{
							target: "none",
							envelope: "none",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Distorted Saw 2",
				generalMidi: false,
				tags: ["chip", "chipwave", "thetunecrusher", "featured"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1.4142 }],
					effects: [
						"panning",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"reverb",
					],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 1.4142,
						},
					],
					distortion: 100,
					aliases: true,
					pan: 0,
					panDelay: 0,
					chorus: 57,
					reverb: 65,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 6,
					wave: "double saw",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 16,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: true,
							index: 0,
						},
						{
							target: "distortion",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
						{
							target: "vibratoDepth",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: true,
						},
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Decay Bass",
				generalMidi: false,
				tags: ["pickedstring", "thetunecrusher"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.3536 }],
					effects: ["panning", "note filter", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.5 }],
					pan: 0,
					panDelay: 0,
					chorus: 71,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					harmonics: [
						57, 100, 43, 29, 14, 14, 14, 14, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0,
					],
					unison: "custom",
					unisonVoices: 9,
					unisonSpread: 0,
					unisonOffset: -12,
					unisonExpression: 1,
					unisonSign: 1,
					stringSustain: 100,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Punch Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "thetunecrusher"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					effects: ["panning", "chorus"],
					pan: 0,
					panDelay: 0,
					chorus: 86,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Sawtooth String Section",
				generalMidi: false,
				tags: ["chip", "chipwave", "thetunecrusher"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 0.5,
						},
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 0.5,
						},
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.7071 },
					],
					effects: ["panning", "vibrato", "note filter", "chorus", "echo", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 250, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 250, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.0884 },
					],
					noteSubFilters1: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 250, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.0884 },
					],
					noteSubFilters2: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 250, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.0884 },
					],
					noteSubFilters4: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 250, linearGain: 0.0884 },
					],
					pan: 0,
					panDelay: 10,
					chorus: 100,
					echoSustain: 0,
					echoDelayBeats: 1,
					reverb: 45,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "sawtooth",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "vibratoDepth",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Rounded Chorus Pad",
				generalMidi: false,
				tags: ["chip", "chipwave", "thetunecrusher"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 2000,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 2000,
							linearGain: 1.4142,
						},
					],
					effects: ["panning", "note filter", "chorus", "reverb"],
					noteFilterType: true,
					noteSimpleCut: 6,
					noteSimplePeak: 0,
					noteFilter: [],
					pan: 0,
					panDelay: 10,
					chorus: 71,
					reverb: 61,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 96,
					wave: "rounded",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "chorus",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "reverb",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Bitcrushed Flute",
				generalMidi: false,
				tags: ["chip", "chipwave", "thetunecrusher"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 }],
					effects: ["panning", "chord type", "vibrato", "bitcrusher", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "custom",
					vibratoDepth: 0.24,
					vibratoDelay: 32,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 29,
					pan: 0,
					panDelay: 10,
					chorus: 43,
					reverb: 74,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 12,
					wave: "triangle",
					unison: "bow",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "chorus",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "reverb",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "unison",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Startoughed Pulse",
				generalMidi: false,
				tags: ["chip", "chipwave", "thetunecrusher"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"panning",
						"transition type",
						"vibrato",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
					],
					pan: 0,
					panDelay: 10,
					chorus: 57,
					echoSustain: 57,
					echoDelayBeats: 1.083,
					reverb: 74,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1/8 pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 8,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Brass Synth 3",
				generalMidi: false,
				tags: ["fm", "fm4op", "thetunecrusher"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 0.5,
						},
					],
					effects: ["panning", "note filter", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 }],
					pan: 0,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 0.5,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Distorted Pulse Vocal 2",
				generalMidi: false,
				tags: ["chip", "chipwave", "thetunecrusher"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					effects: [
						"panning",
						"transition type",
						"vibrato",
						"note filter",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: true,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 8 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2000, linearGain: 8 },
						{ type: "peak", cutoffHz: 4000, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 8 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2000, linearGain: 8 },
						{ type: "peak", cutoffHz: 4000, linearGain: 11.3137 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.0884 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					pan: 0,
					panDelay: 10,
					chorus: 57,
					reverb: 35,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 6,
					wave: "1/4 pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "panning",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Sawtooth Choir",
				generalMidi: false,
				tags: ["chip", "chipwave", "thetunecrusher"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 11.3137 },
					],
					eqSubFilters1: [],
					effects: [
						"panning",
						"transition type",
						"vibrato",
						"note filter",
						"chorus",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: true,
					noteSimpleCut: 4,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 }],
					pan: 0,
					panDelay: 10,
					chorus: 100,
					reverb: 29,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 12,
					wave: "sawtooth",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: true,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Sawtooth Trombone",
				generalMidi: false,
				tags: ["chip", "chipwave", "thetunecrusher"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					effects: ["panning", "vibrato", "note filter", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 2 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.7071 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 2 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.7071 },
					],
					pan: 0,
					panDelay: 10,
					reverb: 81,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "sawtooth",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Distortion Pulse 1",
				generalMidi: false,
				tags: ["chip", "chipwave", "thetunecrusher"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 1,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 1,
						},
					],
					effects: [
						"panning",
						"pitch shift",
						"note filter",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					pitchShiftSemitones: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
					],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 71,
					pan: 0,
					panDelay: 0,
					chorus: 43,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1/4 pulse",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "pitchShift",
							envelope: "none",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Distortion Pulse 2",
				generalMidi: false,
				tags: ["chip", "chipwave", "thetunecrusher"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 1,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 1,
						},
					],
					effects: [
						"panning",
						"pitch shift",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					pitchShiftSemitones: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
					],
					distortion: 71,
					aliases: true,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 71,
					pan: 0,
					panDelay: 0,
					chorus: 43,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1/4 pulse",
					unison: "honky tonk",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			// { name: "", generalMidi: false, tags:["", "thetunecrusher"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "thetunecrusher"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "thetunecrusher"], settings: {} },
		]),
	},
	{
		name: "Bagel's Presets",
		presets: toNameMap([
			{
				name: "grandmaster piano",
				generalMidi: false,
				tags: ["pickedstring", "bagel"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
					],
					effects: ["panning", "reverb"],
					pan: 0,
					panDelay: 0,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					harmonics: [
						100, 100, 86, 86, 71, 71, 0, 71, 71, 71, 71, 71, 71, 14, 57, 57, 57, 57, 57,
						57, 29, 57, 57, 57, 57, 57, 57, 57,
					],
					unison: "fifth",
					stringSustain: 86,
					envelopes: [{ target: "none", envelope: "none" }],
					isDrum: false,
				},
			},
			{
				name: "Filler Bell",
				generalMidi: false,
				tags: ["pickedstring", "bagel"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					effects: ["panning", "bitcrusher", "reverb"],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					pan: 0,
					panDelay: 0,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						43, 71, 0, 100, 0, 100, 0, 86, 0, 0, 86, 0, 14, 71, 14, 14, 57, 14, 14, 43,
						14, 14, 43, 14, 14, 43, 14, 14,
					],
					unison: "shimmer",
					stringSustain: 86,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Warbled Piano",
				generalMidi: false,
				tags: ["pickedstring", "bagel"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 0.0884,
						},
					],
					effects: ["panning", "reverb"],
					pan: 0,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						100, 71, 57, 57, 29, 71, 57, 0, 0, 14, 43, 0, 0, 29, 57, 29, 29, 0, 29, 14,
						14, 14, 0, 0, 0, 0, 14, 0,
					],
					unison: "warbled",
					stringSustain: 71,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Insanely Distorted Spectrum",
				generalMidi: false,
				tags: ["spectrum", "bagel"],
				settings: {
					type: "spectrum",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 0.7071,
						},
					],
					effects: ["panning", "transition type", "distortion", "bitcrusher", "chorus"],
					transition: "continue",
					clicklessTransition: false,
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					pan: 0,
					panDelay: 0,
					chorus: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						100, 71, 29, 57, 57, 43, 0, 100, 0, 86, 43, 71, 29, 14, 100, 0, 71, 14, 100,
						29, 0, 57, 0, 43, 29, 14, 43, 29, 71, 29,
					],
					unison: "none",
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Grace Pulse",
				generalMidi: false,
				tags: ["chip", "chipwave", "bagel"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 }],
					eqSubFilters1: [],
					effects: ["detune", "reverb"],
					detuneCents: 48,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "zefbox triple pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 16,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Extraterrestrial chip",
				generalMidi: false,
				tags: ["chip", "chipwave", "bagel"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "transition type"],
					transition: "continue",
					clicklessTransition: false,
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "todbox beta test wave",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 15,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteVolume", envelope: "tremolo6" }],
					isDrum: false,
				},
			},
			{
				name: "Ascended Choir",
				generalMidi: false,
				tags: ["fm", "fm6op", "bagel"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.7071,
						},
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.7071,
						},
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 1.4142 },
					],
					effects: [
						"panning",
						"transition type",
						"pitch shift",
						"detune",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "continue",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					detuneCents: 40,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					pan: 0,
					panDelay: 10,
					chorus: 14,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 7, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 10, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 11, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 10, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Stereotypical EDM sound",
				generalMidi: false,
				tags: ["chip", "customchip", "bagel"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["panning", "transition type", "vibrato", "chorus", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					pan: 0,
					panDelay: 0,
					chorus: 29,
					reverb: 29,
					fadeInSeconds: 0.075,
					fadeOutTicks: -1,
					wave: "square",
					unison: "dissonant",
					customChipWave: {
						"0": 22,
						"1": 22,
						"2": 16,
						"3": 6,
						"4": 0,
						"5": -3,
						"6": -8,
						"7": -10,
						"8": -13,
						"9": -16,
						"10": -19,
						"11": -19,
						"12": -20,
						"13": -22,
						"14": -22,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -24,
						"19": -24,
						"20": -24,
						"21": -24,
						"22": -24,
						"23": -24,
						"24": -24,
						"25": -24,
						"26": -24,
						"27": -24,
						"28": -24,
						"29": -24,
						"30": -24,
						"31": 24,
						"32": 24,
						"33": 16,
						"34": 9,
						"35": 6,
						"36": 4,
						"37": 2,
						"38": 0,
						"39": -1,
						"40": -3,
						"41": -4,
						"42": -4,
						"43": -6,
						"44": -6,
						"45": -6,
						"46": -6,
						"47": -5,
						"48": -5,
						"49": -4,
						"50": -2,
						"51": -2,
						"52": 1,
						"53": 4,
						"54": 6,
						"55": 8,
						"56": 10,
						"57": 12,
						"58": 14,
						"59": 16,
						"60": 18,
						"61": 19,
						"62": 22,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Insane Saw",
				generalMidi: false,
				tags: ["supersaw", "bagel"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["panning", "vibrato", "note filter", "distortion"],
					vibrato: "delayed",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.5,
						},
					],
					distortion: 86,
					aliases: false,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 47,
					decimalOffset: 0,
					dynamism: 67,
					spread: 75,
					shape: 50,
					envelopes: [{ target: "pulseWidth", envelope: "linear 2" }],
					isDrum: false,
				},
			},
			{
				name: "Church Organ",
				generalMidi: false,
				tags: ["spectrum", "bagel"],
				settings: {
					type: "spectrum",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["panning"],
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					spectrum: [
						100, 0, 29, 0, 14, 0, 14, 100, 14, 14, 29, 86, 0, 0, 100, 29, 57, 0, 86, 29,
						57, 86, 0, 0, 0, 0, 29, 14, 0, 29,
					],
					unison: "vibrate",
					envelopes: [],
					isDrum: false,
				},
			},
			// { name: "", generalMidi: false, tags:["", "bagel"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "bagel"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "bagel"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "bagel"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "bagel"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "bagel"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "bagel"], settings: {} },
		]),
	},
	{
		name: "DamageLol's Presets",
		presets: toNameMap([
			{
				name: "Phighting Lead",
				generalMidi: false,
				tags: ["harmonics", "damagelol"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["transition type", "vibrato", "chorus", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.76,
					vibratoDelay: 28,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					chorus: 43,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 43, 86, 57, 86, 71, 86, 57, 71, 43, 71, 71, 71, 43, 71, 71, 57, 57, 57,
						57, 57, 57, 43, 43, 43, 29, 14, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Onett Bass (earthbound)",
				generalMidi: false,
				tags: ["chip", "customchip", "damagelol", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "peak", cutoffHz: 210.22, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 1681.79,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 4756.83, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 210.22, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 1681.79,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 4756.83, linearGain: 1.4142 },
					],
					eqSubFilters1: [{ type: "low-pass", cutoffHz: 594.6, linearGain: 1 }],
					effects: ["transition type"],
					transition: "continue",
					clicklessTransition: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -2,
						"1": -2,
						"2": -2,
						"3": -2,
						"4": -2,
						"5": -2,
						"6": -2,
						"7": -2,
						"8": -2,
						"9": -2,
						"10": -2,
						"11": -2,
						"12": -2,
						"13": -2,
						"14": -3,
						"15": -3,
						"16": -4,
						"17": -4,
						"18": -5,
						"19": -5,
						"20": -6,
						"21": -6,
						"22": -7,
						"23": -7,
						"24": -7,
						"25": -8,
						"26": -9,
						"27": -9,
						"28": -10,
						"29": -10,
						"30": -10,
						"31": -11,
						"32": -11,
						"33": -12,
						"34": -12,
						"35": -11,
						"36": -10,
						"37": -7,
						"38": -5,
						"39": -3,
						"40": -2,
						"41": -1,
						"42": 2,
						"43": 6,
						"44": 10,
						"45": 12,
						"46": 14,
						"47": 12,
						"48": 9,
						"49": 7,
						"50": 4,
						"51": 2,
						"52": 1,
						"53": 0,
						"54": -1,
						"55": -1,
						"56": -2,
						"57": -2,
						"58": -2,
						"59": -2,
						"60": -2,
						"61": -2,
						"62": -2,
						"63": -2,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Mellow Bell",
				generalMidi: false,
				tags: ["harmonics", "damagelol"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.7071 }],
					eqSubFilters1: [],
					effects: ["vibrato", "chorus", "echo"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					chorus: 57,
					echoSustain: 43,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 0, 0, 71, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 57, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0,
					],
					unison: "octave",
					envelopes: [],
				},
			},
			{
				name: "Sine Bell",
				generalMidi: false,
				tags: ["chip", "chipwave", "damagelol"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 1189.21, linearGain: 0.25 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 1189.21, linearGain: 0.25 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.3536,
						},
					],
					effects: ["transition type", "bitcrusher", "echo", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 0.917,
					reverb: 61,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sine",
					unison: "detune",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Blooky Ghost",
				generalMidi: false,
				tags: ["spectrum", "damagelol"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 2 },
					],
					effects: ["transition type", "chorus", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					panDelay: 0,
					chorus: 100,
					reverb: 45,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 48,
					spectrum: [
						100, 0, 0, 29, 71, 29, 0, 71, 0, 0, 0, 0, 0, 0, 29, 0, 29, 0, 0, 0, 14, 29,
						0, 0, 14, 14, 0, 29, 0, 0,
					],
					unison: "octave",
					envelopes: [],
				},
			},
			{
				name: "CORE Sawtooth",
				generalMidi: false,
				tags: ["chip", "chipwave", "damagelol"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 1.4142,
						},
					],
					effects: ["transition type", "note filter", "chorus", "echo", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					panDelay: 10,
					chorus: 100,
					echoSustain: 57,
					echoDelayBeats: 0.333,
					reverb: 6,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -1,
					wave: "sawtooth",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "DBG Whinesk",
				generalMidi: false,
				tags: ["chip", "customchip", "damagelol"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqSubFilters1: [],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"vibrato",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 0,
					vibrato: "custom",
					vibratoDepth: 0.2,
					vibratoDelay: 19,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 0.667,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "dirty",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": 24,
						"9": 24,
						"10": 24,
						"11": 24,
						"12": 24,
						"13": 24,
						"14": 24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -24,
						"19": -24,
						"20": -24,
						"21": 23,
						"22": 15,
						"23": 11,
						"24": 7,
						"25": 3,
						"26": -1,
						"27": -5,
						"28": -9,
						"29": -4,
						"30": -3,
						"31": 1,
						"32": 5,
						"33": 5,
						"34": 8,
						"35": 13,
						"36": 15,
						"37": 18,
						"38": 14,
						"39": -2,
						"40": -6,
						"41": -6,
						"42": -8,
						"43": -16,
						"44": -20,
						"45": -19,
						"46": -20,
						"47": -10,
						"48": -10,
						"49": -6,
						"50": -4,
						"51": -3,
						"52": -2,
						"53": -5,
						"54": -6,
						"55": -10,
						"56": -11,
						"57": -13,
						"58": -14,
						"59": -18,
						"60": -20,
						"61": -22,
						"62": -24,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Soft Duty Cycle",
				generalMidi: false,
				tags: ["pwm", "damagelol"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato"],
					vibrato: "custom",
					vibratoDepth: 0.12,
					vibratoDelay: 19,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "blip",
							inverse: true,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Energetic Slider Bar",
				generalMidi: false,
				tags: ["fm", "fm4op", "damagelol"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "vibrato", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.32,
					vibratoDelay: 30,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1↔2 3↔4",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Fast Duty Cycle",
				generalMidi: false,
				tags: ["pwm", "damagelol"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato", "note filter", "chorus", "echo"],
					vibrato: "custom",
					vibratoDepth: 0.52,
					vibratoDelay: 25,
					vibratoSpeed: 15,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.1768 }],
					panDelay: 0,
					chorus: 29,
					echoSustain: 29,
					echoDelayBeats: 1.5,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 25,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 5,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 1,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Simple Retro Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "damagelol"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 125,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 125,
							linearGain: 1.4142,
						},
					],
					effects: ["bitcrusher"],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Tenna FM Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "damagelol"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 8000,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 148.65, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 8000,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 148.65, linearGain: 2 },
					],
					effects: ["bitcrusher", "chorus"],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "2→1→6→5→4→3→2",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "18×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.5,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.3333,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.2.3--------------
			{
				name: "Crunch Synth",
				generalMidi: false,
				tags: ["fm", "fm4op", "damagelol"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.1768 }],
					eqSubFilters1: [],
					effects: ["distortion", "chorus"],
					distortion: 71,
					aliases: false,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←(2 3 4)",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorFrequency",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "KSS Fretless Bass",
				generalMidi: false,
				tags: ["chip", "customchip", "damagelol"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 250, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 1414.21,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 250, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 1414.21,
							linearGain: 1.4142,
						},
					],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 0,
						"1": 2,
						"2": 2,
						"3": 0,
						"4": 1,
						"5": 0,
						"6": -3,
						"7": -7,
						"8": -5,
						"9": -4,
						"10": -2,
						"11": -1,
						"12": -3,
						"13": -1,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 2,
						"18": 5,
						"19": 5,
						"20": 7,
						"21": 6,
						"22": 4,
						"23": 5,
						"24": 6,
						"25": 3,
						"26": 1,
						"27": 1,
						"28": 1,
						"29": 1,
						"30": 3,
						"31": 3,
						"32": 2,
						"33": 1,
						"34": 1,
						"35": 0,
						"36": -2,
						"37": -1,
						"38": 0,
						"39": 0,
						"40": -1,
						"41": -1,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 1,
						"46": 3,
						"47": 3,
						"48": 1,
						"49": 0,
						"50": -2,
						"51": 0,
						"52": 1,
						"53": 0,
						"54": -1,
						"55": 0,
						"56": 0,
						"57": 2,
						"58": 4,
						"59": 4,
						"60": 4,
						"61": 3,
						"62": 2,
						"63": 1,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "NES Simple 50% Pulse",
				generalMidi: false,
				tags: ["pwm", "damagelol"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "blip",
							inverse: true,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "NES Simple 20% Pulse",
				generalMidi: false,
				tags: ["pwm", "damagelol"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 20,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "blip",
							inverse: true,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "NES Triangle",
				generalMidi: false,
				tags: ["chip", "chipwave", "damagelol"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 62.5,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 210.22, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 62.5,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 210.22, linearGain: 1.4142 },
					],
					effects: ["transition type"],
					transition: "normal",
					clicklessTransition: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "triangle",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "NES Triangle Pluck",
				generalMidi: false,
				tags: ["chip", "chipwave", "damagelol"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 8000,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 8000,
							linearGain: 2.8284,
						},
					],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "triangle",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "NES Warbly Saw",
				generalMidi: false,
				tags: ["chip", "chipwave", "damagelol"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.3536 }],
					effects: ["vibrato"],
					vibrato: "custom",
					vibratoDepth: 0.4,
					vibratoDelay: 15,
					vibratoSpeed: 5,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sawtooth",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 0.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "NES Guitar Pulse",
				generalMidi: false,
				tags: ["pwm", "damagelol"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.1768 }],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 20,
					decimalOffset: 0,
					unison: "octave",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "blip",
							inverse: true,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.5,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "NES Slap Bass",
				generalMidi: false,
				tags: ["chip", "customchip", "damagelol"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 2 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 500, linearGain: 1.4142 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 2 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 500, linearGain: 1.4142 },
					],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": -1,
						"4": -1,
						"5": -1,
						"6": -2,
						"7": -1,
						"8": 0,
						"9": 1,
						"10": 2,
						"11": 3,
						"12": 3,
						"13": 4,
						"14": 5,
						"15": 6,
						"16": 6,
						"17": 5,
						"18": 5,
						"19": 4,
						"20": 4,
						"21": 3,
						"22": 0,
						"23": -2,
						"24": -6,
						"25": -10,
						"26": -13,
						"27": -14,
						"28": -15,
						"29": -14,
						"30": -13,
						"31": -7,
						"32": 0,
						"33": 7,
						"34": 11,
						"35": 13,
						"36": 16,
						"37": 17,
						"38": 17,
						"39": 15,
						"40": 14,
						"41": 11,
						"42": 8,
						"43": 7,
						"44": 4,
						"45": 3,
						"46": 2,
						"47": 2,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": -1,
						"52": -1,
						"53": -1,
						"54": -1,
						"55": -2,
						"56": -2,
						"57": -2,
						"58": -2,
						"59": -3,
						"60": -3,
						"61": -1,
						"62": 0,
						"63": 0,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "damagelol"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "damagelol"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "damagelol"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "damagelol"], settings: {} },
		]),
	},
];
